import React from "react";
import download from "downloadjs";
import { createForm, formShape } from "rc-form";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-grid-system";
import Modal from "react-awesome-modal";
import CreatableSelect from "react-select/creatable";
import queryString from "query-string";
import { connect } from "react-redux";

import ConversationsPanel from "./ConversationsPanel";
import ApprovalsSection from "./ApprovalsSection";
import SidePanelSection from "./SidePanelSection";
import ContentPropertiesSection from "./ContentPropertiesSection";

import axios from "../../lib/axios-client";
import { apiUrl } from "../../lib/axios-client";
import httpClient from "../../lib/HttpClient";
import history from "../../history";
import LibrarySelect from "../Libraries/LibrarySelect";
import OwnerSelect from "./OwnerSelect";
import security from "../../services/Security";
import accountSetting from "../../services/AccountSetting";
import notificationService from "../../services/Notifications";
import referencesService from "../../services/References";
import paigeReviewService from "../../services/PaigeReview";
import fetchReferenceDocuments from "../../actions/document/fetchReferenceDocuments";
import fetchDocumentReferences from "../../actions/document/fetchDocumentReferences";
import fetchDocumentConversations from "../../actions/document/fetchDocumentConversations";
import fetchClaims from "../../actions/document/fetchClaims";
import fetchDocumentClaims from "../../actions/document/fetchDocumentClaims";
import fetchDocumentDynamicFields from "../../actions/document/fetchDocumentDynamicFields";
import resetDocumentState from "../../actions/document/resetDocumentState";
import ShareLinkAnalyticsModal from "./ShareLinkAnalytics/ShareLinkAnalyticsModal";
import Tooltip from "../Common/Tooltip";

import styles from "./DocumentViewer.module.scss";

import clockIcon from " ../../images/icons/svg/rotate-clock.svg";
import Warning from "../../images/icons/png/warning.svg";
import Lock from "../../images/icons/svg/lock-grey.svg";
import CloudCheckmark from "../../images/icons/svg/cloud-checkmark.svg";
import CloudBadConnection from "../../images/icons/svg/cloud-bad-connection.svg";
import SavingSpinningArrows from "../../images/icons/svg/spinning-saving-arrows.svg";
import DimpleSVG from "../../images/icons/svg/toolbox-dimple-blue.svg";
import BackArrowIcon from "../../images/icons/svg/back-arrow-grey.svg";
import AnnotationLayersIcon from "../../images/icons/svg/annotation-layers.svg";
import editIconOrange from " ../../images/icons/svg/edit-icon-orange.svg";

/* UI Kit */
import {
  UikFormInputGroup,
  UikInput,
  UikButton,
  UikHeadline,
  UikDivider,
  UikDropdown,
  UikDropdownItem,
  Uikon,
  UikToggle,
} from "@uik";
import "@uik/styles.css";
import "../../font.scss";
import "./ReferencePanelAnimation.css";

/* Papercurve Components */
import Header from "../shared/Header/Header";
import Document from "./Document";
import CommentPanel from "./CommentPanel";
import GroupedDocumentReferencesPanel from "./GroupedDocumentReferencesPanel";
import SelectedTextPanel from "./SelectedTextPanel";
import ReferenceDocumentPanel from "./ReferenceDocumentPanel";
import DraftApprovalForm from "../Drafts/DraftApprovalForm";
import InputField from "./DocumentFields/InputField";
import DropDownField from "./DocumentFields/DropDownField";
import TextareaField from "./DocumentFields/TextareaField";
import DateField from "./DocumentFields/DateField";
import DocumentVersionsPanel from "./DocumentVersionsPanel";
import DocumentVersionMessage from "./DocumentVersionMessage";
import DocumentAttachmentsPanel from "./DocumentAttachmentsPanel";
import VideoApp from "../Video/VideoApp";
import Spinner from "../Common/Spinner";
import PDFDocument from "./PDFDocument";
import NewModal from "../Common/Modal";
import ButtonPrimary from "../Common/Buttons/ButtonPrimary";
import AudienceSelect from "./DocumentFields/AudienceSelect";
import { CSSTransition } from "react-transition-group";
import ReferencesLibrary from "../ReferencesLibrary";
import ApprovalCard from "./ApprovalCard";
import SignaturePanel from "./Panels/Signature";
import ShareLink from "./Panels/ShareLink";
import Translations from "./Panels/Translations";
import Chats from "./Panels/Chats";
import PaigeReview from "./Panels/PaigeReview";
import Claims from "./Panels/Claims";
import Template from "./Panels/Template";
import PaigeClaims from "./Panels/PaigeClaims";
import DocumentReferencePanel from "./Panels/DocumentReferences";

/* Variables */
export const SAVING_CONTENT_STATES = {
  SAVED: { text: null, icon: CloudCheckmark },
  SAVING: { text: "Saving...", icon: SavingSpinningArrows },
  FAILED_TO_SAVE: {
    text: "Unable to save document",
    icon: CloudBadConnection,
  },
};

class DocumentViewerBuild extends React.Component {
  constructor() {
    super();

    const user = security.getUser();

    this.documentContainer = null;
    this.checkDocumentTimeout = null;
    this.isCitationSearch = false;
    this.chatCitationHighlight = null;
    this.chatCitationTimeout = null;

    this.state = {
      approval: null,
      document: {},
      docId: null,
      documentOwnerId: null,
      showingVersions: false,
      versionId: null,
      versionDocument: null,
      versionNumber: null,
      versions: [],
      readOnly: false,
      renameModalOpen: false,
      renameAttachmentModalOpen: false,
      documentLoaded: null,
      annotationsLoaded: false,
      initialPage: null,
      selectedBlockId: null,
      conversationBlockId: null,
      referenceBlockId: null,
      documentReferenceBlockId: null,
      documentReferenceId: null,
      conversationPageNumber: null,
      currentUser: {
        id: security.getUserId(),
        role: security.getUserRole(),
      },
      metadata: [],
      documentFieldValuesFormModalOpen: false,
      documentFields: [],
      documentFieldValues: {},
      selectOptions: {},
      metadataLoaded: false,
      attachments: [],
      attachmentId: null,
      attachmentIdx: null,
      attachmentTitle: null,
      showingAttachments: false,
      showingReferences: false,
      showingDocumentReferences: false,
      linkingReferences: false,
      generalComments: null,
      formats: [],
      tags_list: [],
      creatableSelectTagsList: [],
      availableTags: [],
      latestApproved: false,
      editingDocumentReferences: false,
      showReferencesMigratedModal: false,
      inRedefineMode: false,
      redefinedAnnotationXfdfHighlightId: null,
      redefinedXFDF: null,
      redefinedXFDFId: null,
      currentAnnotationText: null,
      docRefsLoadedInMainDoc: false,

      // PDFTron states
      commentXfdfHighlightId: null,
      referenceXfdfHighlightId: null,
      claimXfdfHighlightId: null,
      documentReferenceXfdfHighlightId: null,
      currentXfdfHighlightPageIndex: null,
      currentXfdfHighlightId: null,
      currentXfdfHighlightString: null,
      showContentDetailsModal: false,
      showDeleteModal: false,
      showDeleteAttachmentModal: false,
      showDownloadModal: false,
      addedAnnotations: {},
      queryXfdfId: null,
      selectedCommentId: null,
      selectedLibrary: null,
      latest: false,
      showReferencesLibrary: false,
      showConversationsPanel: false,
      conversations: null,
      documentReferences: null,
      numReferences: 0,
      convoStatusToggled: false,
      updateConvos: false,
      referencesLoaded: false,
      downloadingFile: false,
      savingContentState: null,
      formFieldValues: null,
      signatures: null,
      selectedSignature: null,
      nonVideoVersionsExist: false,
      shareLinks: null,
      showShareLinkPanel: false,
      showTranslationsPanel: false,
      showChatsPanel: false,
      currentChatSessionId: null,
      showPaigeReviewPanel: false,
      paigeReviewStatus: null,
      paigeReviewCriticalCount: 0,
      paigeReviewWarningCount: 0,
      paigeReviewInfoCount: 0,
      showClaimsPanel: false,
      showLinkClaimPanel: false,
      selectedClaim: null,
      claimData: null,
      selectedShareLink: null,
      showActivityModal: false,
      claimToLink: null,
      strikeoutComment: false,
      strikeoutJustAdded: false,
      templateKeys: [],
      templateKeysSchema: {},
      conversationsInitiated: [],
      currentConvoId: null,
      annotLayersClicked: false,
      hideAllAnnotations: false,
      hideComments: false,
      hideReferences: false,
      hideClaims: false,
      hideNativeAnnots: true,
    };
  }

  componentWillMount = () => {
    if (
      this.props.location.state &&
      this.props.location.state.referencesMigrated
    ) {
      this.setState({ showReferencesMigratedModal: true });
    }
    const queryParams = queryString.parse(this.props.location.search);
    if (queryParams.xfdfId) {
      this.setState({ queryXfdfId: queryParams.xfdfId });
    }
    if (queryParams.commentId) {
      this.setState({ selectedCommentId: parseInt(queryParams.commentId) });
    }
    if (queryParams.latest) {
      this.setState({ latest: queryParams.latest === "true" });
    }
    if (queryParams.page) {
      this.setState({ initialPage: parseInt(queryParams.page) });
    }
    if (this.props.location.state && this.props.location.state.versionId) {
      this.setState(
        {
          versionId: this.props.location.state.versionId,
          versionNumber: this.props.location.state.versionNumber,
          docId: this.props.match.params.id,
          pdfDocId: this.props.match.params.id,
        },
        () => {
          this.loadDocument(this.props.location.state.versionId);
        }
      );
    } else {
      this.loadDocument(this.props.match.params.id);
    }

    const passwordSet = this.getQueryStringValue("passwordSet");
    if (passwordSet) {
      this.setState({ passwordSet });
    }

    document.addEventListener("reload_comments", (e) => {
      if (e.detail.docId == this.getDocId()) {
        this.retrieveGeneralComments();
      }
    });

    document.addEventListener("decrement_references", (e) => {
      let numReferences = this.state.numReferences;
      if (numReferences > 0) {
        this.setState({ numReferences: numReferences - 1 });
      }
    });
  };

  componentDidMount = () => {
    window.addEventListener("resize", this.onResize);
    if (this.state.passwordSet) {
      notificationService.addNotification(
        "Your password has been set up",
        "Password set successfully",
        "success"
      );
    }

    if (
      this.props.location.state &&
      this.props.location.state.openTemplatePanel
    ) {
      this.showTemplatePanel();
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.loadDocument(this.props.match.params.id, true);
      this.props.fetchDocumentDynamicFields(this.props.match.params.id);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
    if (this.checkDocumentTimeout) {
      clearTimeout(this.checkDocumentTimeout);
    }
    this.props.resetDocumentState();
  }

  sidePanelContainerCallback = (element) => {
    this.onResize();
  };

  updateSavingContentState = (savingContentState) => {
    this.setState({
      savingContentState,
    });
  };

  onResize = () => {
    //resize the comment panel based on window height and elements
    const header = document.getElementById("usersScreenHeader");
    const sidePanelContainer = document.getElementById("sidePanelContainer");

    // caculate offset to subtract
    let offset = 70; //header.offsetHeight;

    const newHeight = window.innerHeight - offset + 1;

    sidePanelContainer.setAttribute("style", `height:calc(100vh - 70px)`);
  };

  getDocId = () => {
    return this.state.versionId ? this.state.versionId : this.state.docId;
  };

  getGeneralCommentsBlockId = () => {
    return `${this.getDocId()}-general`;
  };

  startEditingDocumentReferences = () => {
    this.setState({ editingDocumentReferences: true });
  };

  stopEditingDocumentReferences = () => {
    this.setState({ editingDocumentReferences: false });
  };

  setRedefineMode = (choice) => {
    this.setState({
      inRedefineMode: choice,
    });
  };

  setUpdatedXFDF = (xfdf, id) => {
    this.setState({
      redefinedXFDF: xfdf,
      redefinedXFDFId: id,
    });
  };

  resetConversationStatusToggle = () => {
    this.setState({
      convoStatusToggled: false,
      updateConvos: false,
    });
  };

  toggleStatus = () => {
    this.setState({
      convoStatusToggled: true,
    });
  };

  setShowActivityModal = (option) => {
    this.setState({
      showActivityModal: option,
    });
  };

  setClaimToLink = (claim) => {
    this.setState({
      claimToLink: claim,
    });
  };

  setAnnotationsLoaded = () => {
    this.setState({ annotationsLoaded: true }, () => {
      // Navigate to initial page if specified in URL query params
      if (this.state.initialPage) {
        const webViewerEl = document.getElementById("webViewer");
        if (webViewerEl) {
          const instance = window.WebViewer.getInstance(webViewerEl);
          if (instance) {
            const documentViewer = instance.Core.documentViewer;
            documentViewer.setCurrentPage(this.state.initialPage);
            // Clear initialPage so we don't navigate again
            this.setState({ initialPage: null });
          }
        }
      }
    });
  };

  setSelectedShareLink = (link) => {
    this.setState({
      selectedShareLink: link,
    });
  };

  loadDocument = (docId, reloadDocument = false) => {
    const userId = this.state.currentUser.id;

    httpClient.get("/tags.json").then((response) => {
      const tags = [];
      response.data.map((option, index) => {
        tags.push({ value: option.name, label: option.name });
      });
      this.setState({ availableTags: tags });
    });

    let versions = null;

    httpClient
      .get(`/documents/${docId}/versions.json`)
      .then((response) => {
        versions = response.data;
        this.setState({
          versions: response.data,
          versionCount: response.data.length,
          latestApproved: response.data[0].approved,
          nonVideoVersionsExist: this.checkForNonVideoVersions(versions),
        });

        let url = `/documents/${docId}.json`;
        if (this.state.versionId) {
          url = `/documents_version/${docId}.json`;
        }

        httpClient
          .get(url)
          .then((response) => {
            let data = {};
            if (!this.state.versionId) {
              if (this.state.latest && versions[0].id != docId) {
                this.loadDocument(versions[0].id);
                history.push(`/drafts/${versions[0].id}`);
                return;
              }
              data.document = versions[0];
              // Add paige_status from the document response (not in versions endpoint)
              data.document.paige_status = response.data.paige_status;
              data.formFieldValues = response.data.form_field_values;
              data.docId = versions[0].id;
              if (data.document.approved) {
                data.readOnly = true;
              }
              let creatableSelectTagsList = [];
              data.document.tags_list.map((tag, idx) => {
                creatableSelectTagsList.push({ label: tag, value: tag });
              });
              data.creatableSelectTagsList = creatableSelectTagsList;
            } else {
              data.versionDocument = response.data;
              if (Object.keys(this.state.document).length === 0) {
                httpClient
                  .get(`/documents/${this.state.docId}.json`)
                  .then((response) => {
                    this.setState({
                      document: response.data,
                      documentOwnerId: response.data.uploaded_by_user_id,
                    });
                  });
              }
            }

            this.setState(data, () => {
              if (!this.state.versionId) {
                if (data.document.document_state_code == "processing") {
                  this.checkDocumentStatus();
                }
              }
              if (versions[0].id != docId) {
                let version = versions.find((version) => version.id == docId);
                this.setState({
                  versionId: docId,
                  readOnly: true,
                  versionNumber: version.version_number,
                });
              }
              if (
                this.state.queryXfdfId &&
                this.state.queryXfdfId.includes("-general")
              ) {
                this.onClickShowGeneralComments();
              }
              this.loadConversations();
              this.loadSignatures();
              this.loadPaigeReviewFindingsCount();
              this.setState(
                {
                  documentLoaded: true,
                },
                () => {
                  if (reloadDocument) {
                    const webViewerEl = document.getElementById("webViewer");
                    const token = security.getToken();

                    const instance = window.WebViewer.getInstance(webViewerEl);

                    if (instance) {
                      instance.Core.documentViewer.loadDocument(
                        `${apiUrl}/documents/${docId}/file${this.state.document.file_extension}`,
                        {
                          customHeaders: {
                            Authorization: `Bearer ${token}`,
                          },
                        }
                      );
                    }
                  }
                }
              );
            });

            // Retrieve all the document user approvals.
            httpClient
              .get(`/documents/${docId}/user_approval/${userId}.json`)
              .then((response) => {
                this.setState({
                  approval: response.data,
                });

                this.props.fetchDocumentDynamicFields(this.getDocId());
                this.props.fetchReferenceDocuments(this.getDocId());
                this.props.fetchClaims(this.getDocId());
                this.retrieveDocumentAttachments();
                this.retrieveDocumentTranslations();
                this.retrieveGeneralComments();
                this.retrieveFormats();
                this.retrieveShareLinks();
              });

            // Retrieve document metadata
            this.retrieveDocumentFields(this.state.document.library_id);
            this.retrieveDocumentFieldValues();
          })
          .catch((error) => {
            if (error.response.status === 404) {
              this.setState({
                document: {},
                documentLoaded: true,
              });
            }
          });
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.setState({
            document: {},
            documentLoaded: true,
          });
        }
      });
  };

  retrieveDocumentFields = (libraryId) => {
    httpClient
      .get(`libraries/${libraryId}/document_fields.json`)
      .then((response) => {
        const documentFields = response.data;
        let selectOptions = {};

        documentFields.map((df) => {
          if (
            df.field_type === "select_options" ||
            df.field_type === "multi_select_options"
          ) {
            selectOptions[df.key] = df.document_field_select_options;
          }
        });

        this.setState({
          documentFields: documentFields,
          selectOptions: selectOptions,
        });
      });
  };

  retrieveShareLinks = () => {
    httpClient.get(`share_links/${this.state.docId}.json`).then((res) => {
      this.setState({
        shareLinks: res.data,
      });
    });
  };

  confirmReferencesLoaded = () => {
    this.setState({
      docRefsLoadedInMainDoc: true,
    });
  };

  getNumberShareLinks = () => {
    let count = 0;

    if (this.state.shareLinks) {
      count = this.state.shareLinks.my_share_links.length;

      if (this.state.shareLinks.others_share_links) {
        count += this.state.shareLinks.others_share_links.length;
      }
    }

    return count;
  };

  getNumberTranslations = () => {
    let count = 0;

    if (this.state.translations) {
      count = this.state.translations.length;
    }

    return count;
  };

  checkDocumentStatus = () => {
    httpClient
      .get(`/documents/${this.state.docId}/check_ready.json`)
      .then((response) => {
        if (response.data.success) {
          clearTimeout(this.checkDocumentTimeout);
          this.loadDocument(this.state.document.id);
        } else {
          this.checkDocumentTimeout = setTimeout(
            this.checkDocumentStatus,
            10000
          );
        }
      });
  };

  retrieveVersions = () => {
    //drafts
    httpClient
      .get(`/documents/${this.state.docId}/versions.json`)
      .then((response) => {
        this.setState({
          versions: response.data,
          versionCount: response.data.length,
        });
      });
  };

  sortDocumentAttachments = (attachments) => {
    return attachments.sort(function (a, b) {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
      return 0;
    });
  };

  sortDocumentTranslations = (translations) => {
    return translations.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
  };

  retrieveDocumentAttachments = () => {
    let docId = this.getDocId();

    httpClient.get(`/documents/${docId}/attachments.json`).then((response) => {
      this.setState(
        {
          attachments: this.sortDocumentAttachments(response.data),
        },
        () => {
          if (this.props.location.hash.includes("attachments")) {
            this.setState({ showingAttachments: true });
          }
        }
      );
    });
  };

  retrieveDocumentTranslations = () => {
    let docId = this.getDocId();

    httpClient.get(`/documents/${docId}/translations.json`).then((response) => {
      this.setState(
        {
          translations: this.sortDocumentTranslations(response.data),
        },
        () => {
          if (this.props.location.hash.includes("translations")) {
            this.setState({ showingTranslations: true });
          }
        }
      );
    });
  };

  retrieveDocumentChats = () => {
    let docId = this.getDocId();

    // TODO
  };

  retrieveGeneralComments = () => {
    let docId = this.getDocId();

    // Retrieve all the document user approvals.
    httpClient
      .get(`/documents/${docId}/general_comments.json`)
      .then((response) => {
        this.setState({
          generalComments: response.data,
        });
      });
  };

  retrieveFormats = () => {
    //drafts
    httpClient
      .get(`/documents/${this.state.docId}/formats.json`)
      .then((response) => {
        this.setState({
          formats: response.data,
        });
      });
  };

  onAddToReference = () => {
    this.setState({
      linkingReferences: true,
      showingReferences: true,
    });
  };

  onClickedVersion = (versionId, versionNumber, fileExtension) => {
    if (
      (this.state.docId == versionId && !this.state.versionId) ||
      versionId == this.state.versionId
    ) {
      return;
    }

    if (this.state.docId != versionId) {
      this.setState(
        { versionId: versionId, readOnly: true, versionNumber: versionNumber },
        () => {
          if (this.state.document.not_pdftron || this.state.document.is_video) {
            this.loadDocument(versionId);
          } else {
            this.handleVersionLoad(versionId, fileExtension);
          }
        }
      );
    } else {
      let readOnly = false;
      if (this.state.document && this.state.document.approved) {
        readOnly = true;
      }
      this.setState(
        {
          versionId: null,
          versionNumber: null,
          readOnly,
          versionDocument: null,
        },
        () => {
          if (this.state.document.not_pdftron || this.state.document.is_video) {
            this.loadDocument(this.state.docId);
          } else {
            this.handleVersionLoad(this.state.docId, fileExtension);
          }
        }
      );
    }
  };

  closeVersion = () => {
    let readOnly = false;
    if (this.state.document && this.state.document.approved) {
      readOnly = true;
    }
    this.setState({ versionId: null, versionNumber: null, readOnly }, () => {
      if (this.state.document.not_pdftron || this.state.document.is_video) {
        this.loadDocument(this.state.docId);
      } else {
        this.handleVersionLoad(
          this.state.docId,
          this.state.document.file_extension
        );
      }
    });
  };

  fileFormat = () => {
    const fileFormats = {
      "application/pdf": "Original format",
      "image/png": "Original format",
      "application/vnd.ms-excel": "Excel",
      "application/vnd.ms-powerpoint": "PowerPoint",
      "text/csv": "CSV",
      "application/msword": "Word",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        "Excel",
      //'application/x-ms-dos-executable': 'Original Form',
      //'application/pdf': 'Original Format',
      "application/vnd.apple.pages": "Apple Pages",
      "text/plain": "Text",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        "PowerPoint",
      "application/vnd.apple.numbers": "Apple Numbers",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "Word",
      //'video/quicktime': 'Quicktime'
    };

    let fileFormatString = "Original format";

    if (fileFormats[this.state.document.mime_type]) {
      fileFormatString = fileFormats[this.state.document.mime_type];
    }

    return fileFormatString;
  };

  handleDownloadPDFWithoutComments = (e) => {
    e.preventDefault();
    this.hideDownloadModal();
    let instance = window.WebViewer.getInstance();

    instance.UI.downloadPdf({
      filename: `${this.state.document.title}.pdf`,
      includeAnnotations: false,
    });
  };

  escapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
  };

  updateConvoStatus = async (conversations) => {
    let pdftron = await window.WebViewer.getInstance();
    let annotationManager =
      await pdftron.Core.documentViewer.getAnnotationManager();
    await annotationManager.setCurrentUser("Papercurve User");
    let resolvedTag = "";
    conversations.map((convo) => {
      if (convo.status === "resolved") {
        if (convo.block_identifier && convo.block_identifier.match("general")) {
          resolvedTag = `<text page="0" color="#FFFF00" flags="hidden,print,nozoom,norotate" title="Papercurve User" subject="Sticky Note" inreplyto="general-comments" icon="Comment" state="Completed" statemodel="Review"><contents>Completed</contents></text>`;
        } else {
          let annot = annotationManager.getAnnotationById(
            convo.xfdf_highlight_id
          );
          if (annot) {
            annotationManager.updateAnnotationState(annot, "Completed");
          }
        }
      }
    });
    this.setState({ downloadingFile: true });
    return resolvedTag;
  };

  handleDownloadPDFWithComments = async (e) => {
    e.preventDefault();
    let resolvedTag = await this.updateConvoStatus(this.state.conversations);
    let instance = window.WebViewer.getInstance();
    let annotationManager = instance.Core.documentViewer.getAnnotationManager();

    annotationManager.exportAnnotations().then((xfdfData) => {
      const docId = this.state.versionId
        ? this.state.versionId
        : this.state.docId;

      let format;

      // Get the comments from the server
      httpClient
        .get(`/documents/${docId}/xfdf/comments.json`)
        .then((response) => {
          const commentImageDataSVGStr =
            "<imagedata>data:image/svg+xml;base64,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</imagedata>";
          const commentImageDataPNGStr =
            "<imagedata>data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAmCAYAAAA1MOAmAAADRElEQVRYR7WXP0wUQRTGv8clQoEROqm4M6HRBrChUghYYaIkJjYSubBnp0JjuCv0aG4vNqCldwSMlYkGCrHRRCAhoREwERqiQHU2IkYLNcExb/f22NuZ2T8cvu5u5s1vvjdv3rwlBJiYHovjoO4KIK4CaALQXnZZB7AP0Bz+YpFu5fi3r5FuVDzJtKNOTADoDlqkPL4AIcYplV/QzVfCRCE9AcJISIhnmphBrGGUktl9r38VTExnm3DwexoAh6wWW0esvscLrIYV07PHAHI2KQErMFEcmwTobi1yZF8xQ0Y+6fxvweyMo20lqOUM0NYBtJ4DTjRUT/nzC9jdALbWgNJn9T6F6HGSxoYV0++UWXfhGsCw1bfA7ibAi7uN4a1ngc4+oPQJWHqpAu6QYSZ4gLSqGHSyGXjzTIZ4l2TopUHgx54aWFZHopAeAYHv06GxGobNPg4GOV4MHLgDLL1QhFQ8IiM/wrAFEC5WwRjEZ7C1Gi1f2jrtsDOw2qxQkiim11wlyJ4yeB94/jC8KmfhxmagP2X7eowMkxgmpJHhHDCViabKma3x1cOu3wPmC8DPb9GAIZRxDTv1n88MtjJVghw5G2/bqS9f8F0yzDhpy1TXZeB0AnhdCE4UTvu+G8DeF2DllSr0T8kwh6j8bnFGysZATmcGfi3J43xGLQmgsxcobatS3vEZIMOcs8uVKpTONL5zDNp6D3T1A23nD6FWbdy076OuNgJWCNmpDBvrBhHXR9n43nxcBjp6gb2S3+7VmUuUpOHcTAXmq46vQWMTsDIPbCxHuwouVR6YRh3D+NA5XFHNpaoKFnh2UUHABzJMpxOzvD09iM8jGhXmejQdV6m7EsU0H+bNqGtXzRdYpJQptYAyzK9FCLsDhSopjM5aopDJgsSDsGt75lnVQuWrblLt/nFHKtBh6DGRoGSefSXTt99HU6dVpQ2jdQ1sdfyx0BpGEIDviNXHVW23NhvdC4upzBCE4HY82ASNUyqX9ZuoDWMlWYppjn+QukBVvmF0wfgjg78B9CYwSilzMkh+oDLr/PyeIE+xrSmMNsznCfIU25phPuqkYns8MFUZ05QlHTDUmVWSxb4KdnoTZZ0XOCgxnPF/leBcNldDc+UAAAAASUVORK5CYII=</imagedata>";
          const referenceImageDataSVGStr =
            "<imagedata>data:image/svg+xml;base64,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</imagedata>";
          const referenceImageDataPNGStr =
            "<imagedata>data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAmCAYAAAA1MOAmAAADU0lEQVRYR7WXT0gUURzHf28W9lhGGEgbuaVBBil1qS4pHQo8ZNhV0lu7Bu06BjkmrZBj4K67gY4FQht2CiQ7GHUw9ZKd8g9khxSNBKGIrEslOC9+b/dtOzNvdmb/+A7LsvP7vc/7ft9vfu8tAYdx+3q8UpJ2LlMqNRGilwGQulQKXaBU2iJEnwDwzKpaeMFpLmIXoATjdZTSOCG03mkShqZkxuPZ6b03dGvGLl4I6wrE4oRAyA1EEJP0eqVwJBHeMj8zwCKheNn2tv4YAJoKBKXT6ILX62kwAw0wJRh7XjyIL9MKzMCU4GACgN4sTpElO6lqchv/lcFSFaevlRjEppMkvYEXDYN1BQan3VZdAQtaVzXZj3lkN1XxhXF1pLs9FqIU4gWsOI8U8kDVOkJECcbwJTxvzmy8Wg/HT1bBvv17hJMuL67Am5dzsLnxzQ2UWUmUYHT+fwtK5SGowncAxsdewY/vv4STnTpzgsUN9IzCn99/HYGqJhNURs2RPdF2GOofs4D81YfAX+1j4R+XVuBcw2lY+/QFNje+QsXBclheWrUF54SZV9zccgmOHPPB+3cfGAxtzIbh95raozCaeCa0lsOwh+3NVneh8SxTMD72mqmrqa3KWMbjRDbibxj79NELi60cJiwQBGLy1ORcpkgQ3NxyMW3jKkxNvrWo6BvugO72QTPss6rJlcRNm8K9wmLAfcw17JQRSp/0jXS2Ejy3APR5p3LCPUNr+Z6Z4/EVQQtFe0YpvdI/0jnB2pXdu2aesMJXziYUDbQYi0bwGjALWbvCjzs3Bup1XZp2Ulfg8zZVk5MZWD7q8gRmVBlgu6Quo8oAK7U6SmGxf0RO38RSfhiuBaU8brIPTW695XbVHYgmKSHX8twbc/isqsmWK6AFVgp1IlUWG/nylGAsAgB3C1HHu4UoV3hJTd8f180N2g1c1yX//YdhzLWMHNfv/NXlUmVrIz5Iq8M/C4fdKAKAn16vVCm6dttWY/bESjDWCgB4HXczelVNxr22HbY2ZhUL+u+kzlFVThs5rCsQbSKE4H8A+xUTCPcNywkn+Y7KcAKHI8jQbIuyEZMdmrSh2RYNs1MnarYlgYnamF1bsgO62rOsysRXgZd3hJ/AToXBn/8D1FuBNvv75/wAAAAASUVORK5CYII=</imagedata>";

          let xfdfString = xfdfData.replace(
            "</annots>",
            response.data.comments + resolvedTag + "</annots>"
          );
          xfdfString = xfdfString.replace(
            new RegExp(this.escapeRegExp(commentImageDataSVGStr), "g"),
            commentImageDataPNGStr
          );
          xfdfString = xfdfString.replace(
            new RegExp(this.escapeRegExp(referenceImageDataSVGStr), "g"),
            referenceImageDataPNGStr
          );

          instance.UI.downloadPdf({
            filename: `${this.state.document.title}.pdf`,
            xfdfString: xfdfString,
          });

          this.hideDownloadModal();
        });
    });
  };

  handleDownload = (e) => {
    e.preventDefault();
    let url = "";
    let title = "";
    let type = "";
    const token = security.getToken();
    const docId = this.state.versionId
      ? this.state.versionId
      : this.state.docId;
    if (this.state.document.is_video) {
      url = this.state.document.video_download_url;
      title = this.state.document.video_file_name;
      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer",
      }).then(function (response) {
        download(response.data, title);
      });
    } else {
      url = `/documents/${docId}/file`;
      title = `${this.state.document.title}${this.state.document.file_extension}`;
      type = this.state.document.mime_type;
      let _that = this;
      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer",
        headers: { Authorization: `Bearer ${token}` },
      }).then(function (response) {
        const content = response.headers["content-type"];
        download(response.data, title, type);
        _that.hideDownloadModal();
      });
    }
  };

  handleFormatDownload = (e, format) => {
    e.preventDefault();
    const token = security.getToken();
    const docId = this.state.versionId
      ? this.state.versionId
      : this.state.docId;

    const _that = this;
    axios({
      method: "get",
      url: `/document_format/${format.id}`,
      responseType: "arraybuffer",
      headers: { Authorization: `Bearer ${token}` },
    }).then(function (response) {
      const content = response.headers["content-type"];
      download(
        response.data,
        `${_that.state.document.title}${format.extension}`,
        format.mime_type
      );
    });
  };

  handleDelete = (e) => {
    e.preventDefault();
    this.showDeleteModal();
  };

  handleDeleteAttachmentModalOpen = (e, id, idx) => {
    e.preventDefault();
    this.setState({
      attachmentId: id,
      attachmentIdx: idx,
    });
    this.showDeleteAttachmentModal();
  };

  handleDownloadModal = (e) => {
    e.preventDefault();
    if (this.state.document.is_video) {
      this.handleDownload(e);
    } else {
      this.showDownloadModal();
    }
  };

  deleteAllVersions = () => {
    httpClient
      .delete(`/documents/${this.state.docId}.json`)
      .then((response) => {
        history.push("/dashboard");
        notificationService.addNotification(
          "Document removed.",
          "Content was successfully deleted.",
          "danger"
        );
      })
      .catch(() => {
        this.hideDeleteModal();
        notificationService.addNotification(
          "Document deletion failed",
          "Document deletion was unsuccessful",
          "warning"
        );
      });
  };

  handleDeleteAttachment = () => {
    httpClient
      .delete(`/document_attachments/${this.state.attachmentId}.json`)
      .then((response) => {
        this.hideDeleteAttachmentModal();
        let documentAttachments = this.state.attachments;
        documentAttachments.splice(this.state.attachmentIdx, 1);
        this.setState({
          attachments: documentAttachments,
        });
        notificationService.addNotification(
          "Attachment removed.",
          "Attachment was successfully deleted.",
          "success"
        );
      })
      .catch(() => {
        this.hideDeleteAttachmentModal();
        notificationService.addNotification(
          "Attachment deletion not permitted",
          "You do not have permission to delete attachments.",
          "warning"
        );
      });
  };

  uploadNewVersion = () => {
    history.push(`/drafts/${this.state.document.id}/update`);
  };

  deleteCurrentVersion = () => {
    let currentVersion = this.state.versionId
      ? this.state.versionId
      : this.state.docId;
    httpClient
      .delete(`/documents/version/${currentVersion}.json`)
      .then((response) => {
        this.hideDeleteModal();
        let currentVersionCount = this.state.versionCount - 1;
        if (currentVersionCount > 0) {
          let versions = this.state.versions.filter((version) => {
            return version.id !== currentVersion;
          });
          if (currentVersion !== this.state.docId) {
            this.setState(
              {
                versionId: null,
                versionNumber: null,
                readOnly: false,
                versionDocument: null,
                versionCount: currentVersionCount,
                versions,
              },
              () => {
                if (
                  this.state.document.not_pdftron ||
                  this.state.document.is_video
                ) {
                  this.loadDocument(this.state.docId);
                } else {
                  this.handleVersionLoad(
                    this.state.docId,
                    this.state.document.file_extension
                  );
                }
              }
            );
          } else {
            history.push(`/drafts/${versions[0].id}`);
            this.setState(
              {
                versionId: null,
                versionNumber: null,
                readOnly: false,
                versionDocument: null,
                versionCount: currentVersionCount,
                versions,
                docId: versions[0].id,
                document: versions[0],
              },
              () => {
                if (
                  this.state.document.not_pdftron ||
                  this.state.document.is_video
                ) {
                  this.loadDocument(this.state.docId);
                } else {
                  this.handleVersionLoad(
                    this.state.docId,
                    this.state.document.file_extension
                  );
                }
              }
            );
          }
          this.onClickCloseVersions();
        } else {
          history.push("/dashboard");
        }

        notificationService.addNotification(
          "Document removed.",
          "Content was successfully deleted.",
          "danger"
        );
      })
      .catch(() => {
        this.hideDeleteModal();
        notificationService.addNotification(
          "Document deletion failed",
          "Document deletion was unsuccessful",
          "warning"
        );
      });
  };

  removeUncommittedClaim = () => {
    let addedAnnotationsArray = Object.keys(this.state.addedAnnotations);
    const webViewerEl = document.getElementById("webViewer");
    const annotationManager =
      window.WebViewer.getInstance(webViewerEl).Core.annotationManager;
    const annot = annotationManager.getAnnotationById(
      addedAnnotationsArray[addedAnnotationsArray.length - 1]
    );

    if (annot && annot.getCustomData("highlight-type") === "claim") {
      let savedClaim = this.props.claims.find(
        (c) => c.xfdf_highlight_id === annot.Id
      );

      let savedDocumentClaim = this.props.documentClaims.find(
        (dc) => dc.xfdf_highlight_id === annot.Id
      );

      if (!savedClaim && !this.state.claimToLink && !savedDocumentClaim) {
        annotationManager.deleteAnnotation(annot);
      }
    }
  };

  addAnnotation = ({ id, xfdf }) => {
    this.removeUncommittedClaim();

    this.setState((prevState) => ({
      addedAnnotations: {
        ...prevState.addedAnnotations,
        [id]: xfdf,
      },
    }));
  };

  handleOpenRenameModal = (e) => {
    e.preventDefault();
    this.setState({ renameModalOpen: true });
  };

  handleCloseRenameModal = (e) => {
    e.preventDefault();
    this.setState({ renameModalOpen: false });
  };

  handleRenameAttachmentModalOpen = (e, title, id, idx) => {
    e.preventDefault();
    this.setState({
      renameAttachmentModalOpen: true,
      attachmentTitle: title,
      attachmentId: id,
      attachmentIdx: idx,
    });
  };

  handleCloseRenameAttachmentModal = (e) => {
    e.preventDefault();
    this.props.form.resetFields();
    this.setState({ renameAttachmentModalOpen: false });
  };

  handleRename = (e) => {
    e.preventDefault();
    this.props.form.validateFields((error, values) => {
      if (!error) {
        const documentFormData = {
          document: {
            title: values["title"],
          },
        };

        httpClient
          .put(`/documents/${this.state.document.id}.json`, documentFormData)
          .then((response) => {
            const doc = this.state.document;
            doc.title = documentFormData.document.title;
            this.setState({
              document: doc,
              renameModalOpen: false,
            });
          });
      } else {
        console.log("error", error, values);
      }
    });
  };

  handleRenameAttachment = (e) => {
    e.preventDefault();
    this.props.form.validateFields((error, values) => {
      if (!error) {
        const attachmentFormData = {
          attachment: {
            title: values["title"],
          },
        };

        httpClient
          .put(
            `/document_attachments/${this.state.attachmentId}.json`,
            attachmentFormData
          )
          .then((response) => {
            this.props.form.resetFields();
            let renamedAttachment = response.data;
            this.hideRenameAttachmentModal();
            let documentAttachments = this.state.attachments;
            documentAttachments.splice(this.state.attachmentIdx, 1);
            documentAttachments.push(renamedAttachment);
            this.setState({
              attachments: this.sortDocumentAttachments(documentAttachments),
            });
            notificationService.addNotification(
              "Attachment renamed.",
              "Attachment has been renamed.",
              "success"
            );
          })
          .catch(() => {
            this.hideRenameAttachmentModal();
            notificationService.addNotification(
              "Attachment renaming not permitted.",
              "You are not permitted to rename attachments.",
              "warning"
            );
          });
      } else {
        console.log("error", error, values);
      }
    });
  };

  showAttachmentFailNotification = () => {
    notificationService.addNotification(
      "File attachment failed.",
      "File failed to upload.",
      "warning"
    );
  };

  removePinStampImage = (xfdfHighlightString) => {
    const pinStampImage = /<imagedata>([^>]*)<\/imagedata>/g;
    const xfdfWithoutPinStampImage = xfdfHighlightString.replace(
      pinStampImage,
      "<imagedata></imagedata>"
    );
    return xfdfWithoutPinStampImage;
  };

  setCurrentAnnotationText = (text) => {
    this.setState({ currentAnnotationText: text });
  };

  linkExistingAnnotation = (ref) => {
    const annotationHighlightXfdfId = localStorage.getItem(
      "annotationHighlightXfdfId"
    );

    const parentDocumentReference = this.props.documentReferences.find(
      (ref) => ref.xfdf_highlight_id === annotationHighlightXfdfId
    );

    const parentAnnotationHighlightXfdfPageNumber = localStorage.getItem(
      "parentAnnotationHighlightXfdfPageNumber"
    );
    const documentReferenceCaption = this.state.currentAnnotationText
      ? this.state.currentAnnotationText
      : localStorage.getItem("currentAnnotationText");
    const annotationHighlightXfdf = localStorage.getItem(
      annotationHighlightXfdfId
    );
    const parentDocId = localStorage.getItem("parentDocumentId");

    const referenceData = {
      reference: {
        document_id: ref.document_id,
        page_number: ref.page.page_number,
        xfdf_highlight_id: ref.xfdf_highlight_id,
        xfdf_highlight_string: this.removePinStampImage(
          ref.xfdf_highlight_string
        ),
        caption: ref.caption,
        label: ref.label,
      },
      document_reference: {
        document_id: parseInt(parentDocId),
        page_number: parseInt(
          parentDocumentReference
            ? parentDocumentReference.page.page_number
            : parentAnnotationHighlightXfdfPageNumber
        ),
        xfdf_highlight_id: annotationHighlightXfdfId,
        xfdf_highlight_string: this.removePinStampImage(
          parentDocumentReference
            ? parentDocumentReference.xfdf_highlight_string
            : annotationHighlightXfdf
        ),
        caption: documentReferenceCaption,
      },
      reference_document: {
        reference_document_label: ref.document.reference_document_label,
      },
    };

    this.onClickCloseReferenceDocumentPanel();
    this.onCloseGroupedDocumentReferencesPanel();

    httpClient
      .post("/references.json", referenceData)
      .then((response) => {
        this.props.fetchDocumentReferences(this.getDocId()).then(() => {
          let refCounter = {};
          this.props.documentReferences.map((i, j) => {
            refCounter[i.xfdf_highlight_id] = 1;
          });

          this.setState(
            {
              referencesLoaded: true,
              references: this.props.documentReferences,
              numReferences: Object.keys(refCounter).length,
              currentAnnotationText: null,
            },
            () => {
              this.onAnnotationSelect(
                ref.page.page_number,
                annotationHighlightXfdfId,
                true
              );
              notificationService.addNotification(
                "Linking completed",
                "Reference annotation has been added.",
                "success"
              );
            }
          );
        });
      })
      .catch((e) => {});
  };

  handleVersionLoad = async (docId, fileExtension) => {
    this.props.fetchDocumentDynamicFields(this.getDocId());
    this.setState({ templateKeys: [], templateKeysSchema: {} });
    const webViewerEl = document.getElementById("webViewer");
    const token = security.getToken();
    const instance = window.WebViewer.getInstance(webViewerEl);

    await this.props.fetchClaims(docId);
    await this.props.fetchDocumentClaims(docId);
    await this.props.fetchDocumentReferences(docId);
    await this.props.fetchDocumentConversations(docId);

    instance.Core.documentViewer.loadDocument(
      `${apiUrl}/documents/${docId}/file${fileExtension}`,
      {
        customHeaders: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    let refCounter = {};
    this.props.documentReferences.map((i, j) => {
      refCounter[i.xfdf_highlight_id] = 1;
    });

    this.setState({
      referencesLoaded: true,
      conversations: this.props.documentConversations,
      references: this.props.documentReferences,
      numReferences: Object.keys(refCounter).length,
    });

    httpClient
      .get(`/documents/${docId}/form_field_values.json`)
      .then((res) => this.setState({ formFieldValues: res.data }));

    this.loadSignatures();

    this.setState({
      pdfDocId: docId,
      versionId: docId,
    });
  };

  onTextSelection = (
    requestedAnnotation,
    pageIndex,
    currentXfdfHighlightId,
    currentXfdfHighlightString
  ) => {
    // This should be passed to (PDFTron) <PDFDocument onTextSelection={this.onTextSelection} />
    // It gets trigger after text selection occurs in PDFTron's WebViewer.
    // We want to retrieve the `currentXfdf*` and utilize them to pin a comment and/or reference highlight.

    if (currentXfdfHighlightId && !this.state.downloadingFile) {
      let updateState = {
        showShareLinkPanel: false,
        showTranslationsPanel: false,
        showChatsPanel: this.isCitationSearch
          ? this.state.showChatsPanel
          : false,
        showPaigeReviewPanel: false,
        showingVersions: false,
        commentXfdfHighlightId: null,
        referenceXfdfHighlightId: null,
        currentXfdfHighlightPageIndex: pageIndex,
        currentXfdfHighlightId: currentXfdfHighlightId,
        currentXfdfHighlightString: currentXfdfHighlightString,
        claimXfdfHighlightId: null,
      };

      if (requestedAnnotation === "reference") {
        updateState["referenceXfdfHighlightId"] = currentXfdfHighlightId;
      } else if (requestedAnnotation === "comment") {
        updateState["commentXfdfHighlightId"] = currentXfdfHighlightId;
      } else if (requestedAnnotation === "strikeout") {
        this.addStrikeout(updateState);
      } else if (requestedAnnotation === "claim") {
        updateState["claimXfdfHighlightId"] = currentXfdfHighlightId;
      }

      this.setState(updateState);
    }
  };

  onAnnotationSelect = (pageIndex, xfdfHighlightId, isReference) => {
    if (!this.state.editingDocumentReferences) {
      let conversationAnnotationOnPapercurve = this.state.conversations.find(
        (conversation) => conversation.xfdf_highlight_id === xfdfHighlightId
      );
      let referenceAnnotationOnPapercurve = this.props.documentReferences.find(
        (ref) => ref.xfdf_highlight_id === xfdfHighlightId
      );

      let claimAnnotationOnPapercurve = this.props.claims.find(
        (claim) => claim.xfdf_highlight_id === xfdfHighlightId
      );

      let documentClaimAnnotationOnPapercurve = this.props.documentClaims.find(
        (documentClaim) => documentClaim.xfdf_highlight_id === xfdfHighlightId
      );

      if (
        conversationAnnotationOnPapercurve ||
        referenceAnnotationOnPapercurve ||
        claimAnnotationOnPapercurve ||
        documentClaimAnnotationOnPapercurve
      ) {
        let updateState = {
          selectedBlockId: null,
          conversationBlockId: null,
          referenceBlockId: null,
          showingVersions: false,
          showingReferences: false,
          showingDocumentReferences: false,

          currentXfdfHighlightPageIndex: pageIndex,
          currentXfdfHighlightId: xfdfHighlightId,

          referenceXfdfHighlightId: null,
          documentReferenceXfdfHighlightId: null,
          commentXfdfHighlightId: null,
          claimXfdfHighlightId: null,
        };

        if (this.state.addedAnnotations[xfdfHighlightId]) {
          updateState.currentXfdfHighlightString =
            this.state.addedAnnotations[xfdfHighlightId];
        }

        if (isReference) {
          updateState["documentReferenceXfdfHighlightId"] = xfdfHighlightId;
          if (
            this.props.location.state &&
            this.props.location.state.newAnnotationAdded
          ) {
            notificationService.addNotification(
              "Linking completed",
              "Reference annotation has been added.",
              "success"
            );
          }
        } else if (
          claimAnnotationOnPapercurve ||
          documentClaimAnnotationOnPapercurve
        ) {
          updateState["showClaimsPanel"] = true;
          updateState["selectedClaim"] = claimAnnotationOnPapercurve
            ? claimAnnotationOnPapercurve
            : documentClaimAnnotationOnPapercurve;
        } else {
          updateState["commentXfdfHighlightId"] = xfdfHighlightId;
          updateState["showConversationsPanel"] = true;
        }
        let baseURL = this.props.location.pathname.replace(
          /^(\/[^/]*\/[^/]*).*/,
          "$1"
        );
        history.replace(
          `${baseURL}?xfdfId=${xfdfHighlightId}${
            this.state.selectedCommentId
              ? `&commentId=${this.state.selectedCommentId}`
              : ""
          }`
        );
        this.setState(updateState);
      }
    }
  };

  onAnnotationDeselect = () => {
    this.setState(
      {
        referenceXfdfHighlightId: null,
        commentXfdfHighlightId: null,
        documentReferenceXfdfHighlightId: null,
        currentXfdfHighlightPageIndex: null,
        currentXfdfHighlightId: null,
        currentXfdfHighlightString: null,
        claimXfdfHighlightId: null,
        selectedCommentId: null,
        linkingReferences: false,
        showingReferences: false,
        selectedSignature: null,
      },
      () => {
        history.replace(
          `${this.props.location.pathname.replace(
            /^(\/[^/]*\/[^/]*).*/,
            "$1"
          )}?latest=true`
        );
      }
    );
  };

  onHighlightedBlock = (e) => {
    let unhighlightElements = document.getElementsByClassName("referencedText");
    while (unhighlightElements[0]) {
      unhighlightElements[0].classList.remove("referencedText");
    }

    unhighlightElements = document.getElementsByClassName("commentedText");
    while (unhighlightElements[0]) {
      unhighlightElements[0].classList.remove("commentedText");
    }

    this.setState({
      selectedBlockId: e,
      conversationBlockId: null,
      referenceBlockId: null,
      documentReferenceBlockId: null,
      documentReferenceId: null,
      showingVersions: false,
      showingAttachments: false,
      showingReferences: false,
      showShareLinkPanel: false,
      showTranslationsPanel: false,
      showChatsPanel: false,
      showPaigeReviewPanel: false,
    });
  };

  onClickedConversationIndicator = (e) => {
    this.onCloseGroupedDocumentReferencesPanel();

    let pageNumber = e.split("-")[2];
    if (e == this.getGeneralCommentsBlockId()) {
      pageNumber = 1;
    }

    this.setState({
      conversationBlockId: e,
      conversationPageNumber: pageNumber,
      selectedBlockId: null,
      referenceBlockId: null,
      documentReferenceBlockId: null,
      documentReferenceId: null,
      showingVersions: false,
      showingAttachments: false,
      showingReferences: false,
    });
  };

  onClickEditor = () => {
    console.log("this.state.document", this.state.document);
    history.push(`/editor/${this.state.docId}`);
  };

  onClickShowGeneralComments = () => {
    this.setState({
      conversationBlockId: this.getGeneralCommentsBlockId(),
      conversationPageNumber: 1,
      selectedBlockId: null,
      referenceBlockId: null,
      documentReferenceBlockId: null,
      documentReferenceId: null,
      showingVersions: false,
      showingAttachments: false,
      showingReferences: false,
      showShareLinkPanel: false,
      showTranslationsPanel: false,
      showChatsPanel: false,
      showPaigeReviewPanel: false,
      commentXfdfHighlightId: null,
      documentReferenceXfdfHighlightId: null,
    });
    let baseURL = this.props.location.pathname.replace(
      /^(\/[^/]*\/[^/]*).*/,
      "$1"
    );
    history.replace(
      `${baseURL}?xfdfId=${this.getGeneralCommentsBlockId()}${
        this.state.selectedCommentId
          ? `&commentId=${this.state.selectedCommentId}`
          : ""
      }`
    );
  };

  onClickShowConversationsPanel = () => {
    this.setState({
      showConversationsPanel: true,
      selectedBlockId: null,
      referenceBlockId: null,
      documentReferenceBlockId: null,
      documentReferenceId: null,
      showingVersions: false,
      showingAttachments: false,
      showShareLinkPanel: false,
      showTranslationsPanel: false,
      showChatsPanel: false,
      showPaigeReviewPanel: false,
      showingReferences: false,
      commentXfdfHighlightId: null,
      documentReferenceXfdfHighlightId: null,
    });

    window.location.hash = "comments";
  };

  onClickedReferenceIndicator = (e, id) => {
    this.onCloseConversation();
    this.setState({
      documentReferenceBlockId: e,
      documentReferenceId: id,
      selectedBlockId: null,
      conversationBlockId: null,
      referenceBlockId: null,
      showingVersions: false,
      showingAttachments: false,
      showShareLinkPanel: false,
      showTranslationsPanel: false,
      showChatsPanel: false,
      showPaigeReviewPanel: false,
    });
  };

  onConversationSelection = () => {
    const blockId = this.state.selectedBlockId;
    const unhighlightElements = document.getElementsByClassName(
      "selectedDocumentText"
    );

    this.setState({
      selectedBlockId: null,
      referenceBlockId: null,
      documentReferenceBlockId: null,
      conversationBlockId: blockId,
      conversationPageNumber: blockId.split("-")[2],
      showingVersions: false,
      showingAttachments: false,
      showingReferences: false,
      showShareLinkPanel: false,
      showTranslationsPanel: false,
      showChatsPanel: false,
      showPaigeReviewPanel: false,
    });

    while (unhighlightElements[0]) {
      unhighlightElements[0].classList.add("commentedText");
      unhighlightElements[0].classList.remove("selectedDocumentText");
    }
  };

  onReferenceSelection = () => {
    const blockId = this.state.selectedBlockId;
    const unhighlightElements = document.getElementsByClassName(
      "selectedDocumentText"
    );

    this.setState({
      conversationBlockId: null,
      documentReferenceBlockId: null,
      selectedBlockId: null,
      referenceBlockId: blockId,
      referencePageNumber: blockId.split("-")[2],
      showingVersions: false,
      showingAttachments: false,
      showingReferences: false,
      showShareLinkPanel: false,
      showTranslationsPanel: false,
      showChatsPanel: false,
      showPaigeReviewPanel: false,
    });

    while (unhighlightElements[0]) {
      unhighlightElements[0].classList.add("referencedText");
      unhighlightElements[0].classList.remove("selectedDocumentText");
    }
  };

  onCloseConversation = (closeConversationsPanel = false, removeHighlight) => {
    const unhighlightElements =
      document.getElementsByClassName("commentedText");

    while (unhighlightElements[0]) {
      unhighlightElements[0].classList.remove("commentedText");
    }

    if (removeHighlight) {
      const webViewerEl = document.getElementById("webViewer");
      const annotationManager =
        window.WebViewer.getInstance(webViewerEl).Core.annotationManager;
      const annot = annotationManager.getAnnotationById(
        this.state.currentXfdfHighlightId
          ? this.state.currentXfdfHighlightId
          : this.state.currentConvoId
      );

      this.setState({ currentXfdfHighlightId: null });
      annotationManager.deleteAnnotation(annot);
    }

    this.setState(
      {
        conversationBlockId: null,
        referenceXfdfHighlightId: null,
        commentXfdfHighlightId: null,
        currentXfdfHighlightPageIndex: null,
        currentXfdfHighlightId: null,
        currentXfdfHighlightString: null,
        selectedCommentId: null,
        showConversationsPanel: !closeConversationsPanel,
      },
      () => {
        history.replace(
          `${this.props.location.pathname.replace(
            /^(\/[^/]*\/[^/]*).*/,
            "$1"
          )}?latest=true`
        );
      }
    );
  };

  onClosePDFDocumentConversation = () => {
    this.setState(
      {
        conversationBlockId: null,
        referenceXfdfHighlightId: null,
        commentXfdfHighlightId: null,
        currentXfdfHighlightPageIndex: null,
        currentXfdfHighlightId: null,
        currentXfdfHighlightString: null,
        selectedCommentId: null,
      },
      () => {
        history.replace(
          `${this.props.location.pathname.replace(
            /^(\/[^/]*\/[^/]*).*/,
            "$1"
          )}?latest=true`
        );
      }
    );
  };

  onCloseReferenceLibrary = (addedNewReferenceDocument = null) => {
    this.setState({ showReferencesLibrary: false });
    if (addedNewReferenceDocument) {
      this.props.fetchReferenceDocuments(this.getDocId()).then(() => {
        notificationService.addNotification(
          "Reference Document Linked",
          "New Reference Document has been added.",
          "success"
        );
      });
    } else if (addedNewReferenceDocument === false) {
      notificationService.addNotification(
        "Reference Document Already Linked",
        "This reference document is already linked.",
        "information"
      );
    }
  };

  onCloseGroupedDocumentReferencesPanel = (deleteAnnotation = false) => {
    const unhighlightElements =
      document.getElementsByClassName("referencedText");

    this.onStopLinkingReferences();

    while (unhighlightElements[0]) {
      unhighlightElements[0].classList.remove("referencedText");
    }

    if (deleteAnnotation) {
      const webViewerEl = document.getElementById("webViewer");
      const annotationManager =
        window.WebViewer.getInstance(webViewerEl).Core.annotationManager;
      const annot = annotationManager.getAnnotationById(
        this.state.currentXfdfHighlightId
      );

      annotationManager.deleteAnnotation(annot);
    }

    this.setState({
      referenceXfdfHighlightId: null,
      documentReferenceXfdfHighlightId: null,
      referenceBlockId: null,
      conversationBlockId: null,
      commentXfdfHighlightId: null,
      currentXfdfHighlightPageIndex: null,
      currentXfdfHighlightId: null,
      currentXfdfHighlightString: null,
    });
  };

  //Commenting out this function as it doesn't appear to be in use.
  // onCloseDocumentReferencePanel = (e) => {
  //   const unhighlightElements =
  //     document.getElementsByClassName("referencedText");

  //   while (unhighlightElements[0]) {
  //     unhighlightElements[0].classList.remove("referencedText");
  //   }

  //   this.setState({
  //     documentReferenceBlockId: null,
  //     referenceXfdfHighlightId: null,
  //     commentXfdfHighlightId: null,
  //     documentReferenceXfdfHighlightId: null,
  //     currentXfdfHighlightPageIndex: null,
  //     currentXfdfHighlightId: null,
  //     currentXfdfHighlightString: null,
  //   });
  // };

  onCloseSelectedTextPanel = () => {
    const unhighlightElements = document.getElementsByClassName(
      "selectedDocumentText"
    );

    while (unhighlightElements[0]) {
      unhighlightElements[0].classList.remove("selectedDocumentText");
    }

    this.setState({ selectedBlockId: null });
  };

  onCloseConversationsPanel = () => {
    this.setState({
      showConversationsPanel: false,
      documentReferenceBlockId: null,
      referenceXfdfHighlightId: null,
      commentXfdfHighlightId: null,
      documentReferenceXfdfHighlightId: null,
      currentXfdfHighlightPageIndex: null,
      currentXfdfHighlightId: null,
      currentXfdfHighlightString: null,
    });
  };

  onLibraryChange = (selectedLibrary) => {
    this.setState({
      selectedLibrary,
    });

    this.retrieveDocumentFields(selectedLibrary.value);
  };

  onOwnerChange = (selectedOwner) => {
    this.setState({
      selectedOwner,
    });
  };

  addStrikeout = ({
    currentXfdfHighlightPageIndex,
    currentXfdfHighlightId,
    currentXfdfHighlightString,
  }) => {
    this.setState({
      strikeoutComment: true,
      strikeoutJustAdded: true,
      conversationBlockId: null,
    });

    const commentData = {
      conversation: {
        document_id: parseInt(this.state.docId),
        page_number: parseInt(currentXfdfHighlightPageIndex) + 1,
        xfdf_highlight_id: currentXfdfHighlightId,
        xfdf_highlight_string: currentXfdfHighlightString,
      },
      comment: {
        body: null,
      },
    };

    httpClient.post("/comments.json", commentData).then((response) => {
      this.loadConversations();
    });
  };

  renderLibraryName = () => {
    return (
      <div className={styles.metadataFieldContainerLibrary}>
        <div className={styles.metadataField}>
          <span className={styles.metadataFieldLabel}>Library</span>
          <span className={styles.metadataFieldValue}>
            {this.state.document.library_name}
          </span>
        </div>
      </div>
    );
  };

  renderOwnerName = () => {
    if (
      this.state.document.owner_name &&
      accountSetting.getSetting("content_owner") === "TRUE"
    ) {
      return (
        <div className={styles.metadataFieldContainerOwner}>
          <div className={styles.metadataField}>
            <span className={styles.metadataFieldLabel}>Owner</span>
            <span className={styles.metadataFieldValue}>
              {this.state.document.owner_name}
            </span>
          </div>
        </div>
      );
    }
  };

  renderOwnerField = () => {
    return (
      <div>
        {this.checkReadOnly() ? (
          <div>
            <div className={styles.ownerTitle}>Owner</div>
            <UikInput value={this.state.document.owner_name} disabled={true} />
          </div>
        ) : (
          <OwnerSelect
            libraryId={this.state.document.library_id}
            currentOwnerName={this.state.document.owner_name}
            currentOwnerId={this.state.document.uploaded_by_user_id}
            onOwnerChange={this.onOwnerChange}
          />
        )}
      </div>
    );
  };

  checkReadOnly = () => {
    if (
      this.state.document.uploaded_by_user_id === security.getUserId() ||
      security.getUserRole() === "admin"
    ) {
      return false;
    } else {
      return true;
    }
  };

  renderDocumentFieldValues = () => {
    return (
      <div className={styles.metadataFieldContainerMetadata}>
        {this.state.metadata.map((metadata, idx) => {
          if (
            metadata.document_field.field_type === "sequential" &&
            !metadata.value
          ) {
            return;
          } else {
            return (
              <div key={metadata.id} className={styles.metadataField}>
                <span className={styles.metadataFieldLabel}>
                  {metadata.document_field.label}
                </span>
                <span
                  className={styles.metadataFieldValue}
                  data-cy={metadata.document_field.label}
                >
                  {metadata.display}
                </span>
              </div>
            );
          }
        })}
      </div>
    );
  };

  renderDocumentTagValues = (document) => {
    if (this.state.creatableSelectTagsList.length === 0) {
      const tagList = document.tags_list.map((tag) => {
        return { label: tag, value: tag };
      });
      this.setState({ creatableSelectTagsList: tagList });
    }

    return (
      <div className={styles.tagsContainer}>
        <span className={styles.metadataFieldLabel}>Tags</span>
        {document.tags_list.map((tag, idx) => {
          return (
            <div key={tag} className={styles.tag}>
              {tag}
            </div>
          );
        })}
      </div>
    );
  };

  toggleConversationStatus = (conversation) => {
    let status = "resolved";
    if (conversation.status === "resolved") {
      status = "unresolved";
    }

    this.setState({ convoStatusToggled: true });

    httpClient
      .put(
        `/conversations/${
          conversation.xfdf_highlight_id || conversation.block_identifier
        }.json`,
        {
          conversation: {
            status,
          },
        }
      )
      .then((res) => {
        this.loadConversations();
      });
  };

  renderEditDocumentFieldValuesForm = () => {
    let documentFields = {};

    this.state.metadata.map((metadata, idx) => {
      documentFields[metadata.document_field.key] = metadata.value;
    });

    const customCreatableSelectStyles = {
      control: (base) => ({
        ...base,
        maxHeight: 100,
        overflow: "auto",
      }),
    };

    let libraryReadOnly = this.state.versions.find((version) => {
      if (!version.updatable_library) {
        return true;
      }
    });

    let handleSequentialValue = (field) => {
      let sequentialValue = this.state.documentFieldValues[field.key];

      if (
        !sequentialValue &&
        field.field_value &&
        !field.field_value.includes("@") &&
        this.state.metadata.generate_sequential_display
      ) {
        sequentialValue = field.field_value;
      } else if (!sequentialValue) {
        // Signals that there is no value set..
        sequentialValue = `${field.label} is not assigned`;
      }

      return sequentialValue;
    };

    return (
      <div className={styles.metadataContainer}>
        <div className={styles.metadataSingleLineInputFields}>
          <LibrarySelect
            onLibraryChange={this.onLibraryChange}
            library_id={this.state.document.library_id}
            library_name={this.state.document.library_name}
            readOnly={!this.state.document.updatable_library}
          />
          {!this.state.document.updatable_library && (
            <div className={styles.libraryNotUpdatable}>
              <img src={Lock} />
              <div className={styles.libraryNotUpdatableText}>
                Library cannot be changed since there are shared references in
                this document.
              </div>
            </div>
          )}
          {accountSetting.getSetting("content_owner") === "TRUE" &&
            this.renderOwnerField()}
          {this.state.documentFields.map((field, idx) => {
            if (field.field_type === "input") {
              return (
                <div data-cy={field.key}>
                  <InputField
                    label={field.label}
                    name={field.key}
                    defaultValue={this.state.documentFieldValues[field.key]}
                    required={field.required}
                    values={this.state.documentFieldValues}
                  />
                </div>
              );
            } else if (
              (field.field_type === "select_options" ||
                field.field_type === "multi_select_options") &&
              typeof this.state.documentFieldValues[field.key] !== "undefined"
            ) {
              return (
                <div data-cy={field.key}>
                  <AudienceSelect
                    fieldType={field.field_type}
                    label={field.label}
                    name={field.key}
                    options={this.state.selectOptions[field.key]}
                    values={this.state.documentFieldValues}
                    defaultValue={this.state.documentFieldValues[field.key]}
                  />
                </div>
              );
            } else if (
              (field.field_type === "select_options" ||
                field.field_type === "multi_select_options") &&
              this.state.metadataLoaded
            ) {
              return (
                <div data-cy={field.key}>
                  <AudienceSelect
                    fieldType={field.field_type}
                    label={field.label}
                    name={field.key}
                    options={this.state.selectOptions[field.key]}
                    values={this.state.documentFieldValues}
                  />
                </div>
              );
            } else if (
              field.field_type === "date_time" &&
              this.state.metadataLoaded
            ) {
              return (
                <div data-cy={field.key}>
                  <DateField
                    label={field.label}
                    name={field.key}
                    defaultValue={this.state.documentFieldValues[field.key]}
                    required={field.required}
                    values={this.state.documentFieldValues}
                    dateReminders={field.date_reminders}
                  />
                </div>
              );
            } else if (
              field.field_type === "sequential" &&
              this.state.metadataLoaded
            ) {
              return (
                <div className={styles.textMetadataField}>
                  <span className={styles.metadataFieldLabel}>
                    {field.label}
                  </span>
                  <span className={styles.metadataFieldValue}>
                    {handleSequentialValue(field)}
                  </span>
                </div>
              );
            }
          })}
        </div>
        <div className={styles.metadataMultilineInputFields}>
          {this.state.documentFields.map((field, idx) => {
            if (field.field_type === "textarea") {
              return (
                <div key={field.key} data-cy={field.key}>
                  <TextareaField
                    label={field.label}
                    name={field.key}
                    defaultValue={this.state.documentFieldValues[field.key]}
                    required={field.required}
                    values={this.state.documentFieldValues}
                  />
                </div>
              );
            }
          })}
          <span className={"uik-content-title__wrapper"}>Tags</span>
          <CreatableSelect
            isMulti
            onChange={this.handleChangeCreatableSelect}
            styles={customCreatableSelectStyles}
            options={this.state.availableTags}
            value={this.state.creatableSelectTagsList || []}
          />
        </div>
      </div>
    );
  };

  handleOpenMetadataModal = (e) => {
    e.preventDefault();
    this.setState({ documentFieldValuesFormModalOpen: true });
  };

  handleCloseMetadataModal = (e) => {
    this.setState({ documentFieldValuesFormModalOpen: false });
  };

  handleMetadataSave = (e) => {
    console.log(this.state.documentFieldValues);
  };

  hideContentDetailsModal = () => {
    this.setState({
      showContentDetailsModal: false,
    });
  };

  showContentDetailsModal = (e) => {
    e.preventDefault();
    this.setState({
      showContentDetailsModal: true,
    });
  };

  showDeleteModal = () => {
    this.setState({
      showDeleteModal: true,
    });
  };

  showDeleteAttachmentModal = () => {
    this.setState({
      showDeleteAttachmentModal: true,
    });
  };

  hideDeleteAttachmentModal = () => {
    this.setState({
      showDeleteAttachmentModal: false,
    });
  };

  hideRenameAttachmentModal = () => {
    this.setState({
      renameAttachmentModalOpen: false,
    });
  };

  hideDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
    });
  };

  hideReferencesMigratedModal = () => {
    this.setState({
      showReferencesMigratedModal: false,
    });
  };

  showDownloadModal = () => {
    this.setState({
      showDownloadModal: true,
    });
  };

  hideDownloadModal = () => {
    this.setState({
      showDownloadModal: false,
      downloadingFile: false,
    });
  };

  generateCommentorUsers = () => {
    let commentorUsers = [];

    if (!this.state.versionId) {
      if (this.state.document) {
        commentorUsers = this.state.document.commentor_users;
      }
    } else {
      let foundVersions = this.state.versions.find(
        (version) => version.id === this.state.versionId
      );
      if (foundVersions) {
        commentorUsers = foundVersions.commentor_users;
      }
    }

    return commentorUsers;
  };

  handleGoBack = () => {
    if (history.length === 1) {
      history.push("/dashboard");
    } else {
      history.goBack();
    }
  };

  setConversationsInitiated = (latest, clear) => {
    let convoQue;
    if (clear) {
      convoQue = [];
    } else {
      convoQue = [...this.state.conversationsInitiated];
      convoQue.push(latest);
    }

    this.setState({ conversationsInitiated: convoQue });
  };

  setPreviousConvoId = (id) => {
    this.setState({ currentConvoId: id });
  };

  loadConversations = () => {
    this.props
      .fetchDocumentConversations(
        this.state.versionId ? this.state.versionId : this.state.docId
      )
      .then((response) => {
        let conversations = response;
        if (this.state.convoStatusToggled) {
          this.setState({
            conversations: conversations,
            updateConvos: true,
          });
        } else {
          this.setState({
            conversations: conversations,
          });
        }
      });

    if (!this.state.referencesLoaded) {
      this.props
        .fetchDocumentReferences(
          this.state.versionId ? this.state.versionId : this.state.docId
        )
        .then((response) => {
          let refCounter = {};
          response.map((i, j) => {
            refCounter[i.xfdf_highlight_id] = 1;
          });

          this.setState({
            referencesLoaded: true,
            references: response,
            numReferences: Object.keys(refCounter).length,
          });
        });
    }
  };

  loadSignatures = async () => {
    const response = await httpClient.get(
      `/documents/${
        this.state.versionId ? this.state.versionId : this.state.docId
      }/signatures.json`
    );

    this.setState({ signatures: response.data });
  };

  setSelectedSignature = (selectedSignature) => {
    this.setState({ selectedSignature });
  };

  handleDocumentFieldValuesUpdate = (e) => {
    e.preventDefault();
    let docId = this.state.versionId ? this.state.versionId : this.state.docId;
    const documentFieldsData = {};

    this.state.documentFields.map((field, idx) => {
      if (field.field_type === "sequential") {
        if (!this.state.documentFieldValues[field.key]) {
          // Commenting this out because we do not want to assign new values to old files
          //documentFieldsData[field.key] = field.field_value;
        }
      } else {
        documentFieldsData[field.key] =
          this.state.documentFieldValues[field.key];
      }
    });
    if (this.state.selectedLibrary || this.state.selectedOwner) {
      let documentData;
      if (this.state.selectedLibrary && !this.state.selectedOwner) {
        documentData = {
          library_id: this.state.selectedLibrary.value,
        };
      } else if (!this.state.selectedLibrary && this.state.selectedOwner) {
        documentData = {
          uploaded_by_user_id: this.state.selectedOwner.value,
        };
      } else if (this.state.selectedLibrary && this.state.selectedOwner) {
        documentData = {
          library_id: this.state.selectedLibrary.value,
          uploaded_by_user_id: this.state.selectedOwner.label,
        };
      }
      httpClient
        .put(`/documents/${this.state.document.id}.json`, {
          document: documentData,
        })
        .then((response) => {
          // Save the metadata values.
          httpClient
            .put(`/documents/${docId}/document_field_values.json`, {
              document_field_values: documentFieldsData,
            })
            .then((response) => {
              this.retrieveDocumentFieldValues();
              this.hideContentDetailsModal();
            });
          this.setState({
            selectedLibrary: null,
            selectedOwner: null,
            document: response.data,
          });
        });
    } else {
      // Save the metadata values.
      httpClient
        .put(`/documents/${docId}/document_field_values.json`, {
          document_field_values: documentFieldsData,
        })
        .then((response) => {
          this.retrieveDocumentFieldValues();
          this.hideContentDetailsModal();
        });
    }

    const documentFormData = {};

    documentFormData.tags_list = this.state.document.tags_list;

    httpClient
      .post(`/documents/${this.state.document.id}/tags.json`, documentFormData)
      .then((response) => {});
  };

  retrieveDocumentFieldValues = () => {
    httpClient
      .get(`/documents/${this.state.docId}/metadata.json`)
      .then((response) => {
        let documentFieldValues = {};

        response.data.map((metadata, idx) => {
          if (metadata.document_field.field_type == "multi_select_options") {
            try {
              documentFieldValues[metadata.document_field.key] = JSON.parse(
                metadata.value
              );
            } catch (e) {
              documentFieldValues[metadata.document_field.key] = [
                metadata.value,
              ];
            }
          } else {
            documentFieldValues[metadata.document_field.key] = metadata.value;
          }
        });

        this.setState({
          metadata: response.data,
          documentFieldValues: documentFieldValues,
          metadataLoaded: true,
        });
      });
  };

  onClickShowVersions = () => {
    this.setState({ showingVersions: true });
  };

  renderVersionMessage = () => {
    if (this.state.versionId && this.state.docId != this.state.versionId) {
      return (
        <DocumentVersionMessage
          closeVersion={this.closeVersion}
          message={`Version ${this.state.versionNumber} - Read Only`}
        />
      );
    }
  };

  setDocumentReferenceId = (documentReferenceId) => {
    this.setState({
      documentReferenceId,
    });
  };

  deleteDocumentReference = () => {
    httpClient
      .delete(`/document_references/${this.state.documentReferenceId}.json`)
      .then((response) => {
        if (this.state.currentXfdfHighlightId) {
          const webViewerEl = document.getElementById("webViewer");
          const annotationManager =
            window.WebViewer.getInstance(webViewerEl).Core.annotationManager;
          const annot = annotationManager.getAnnotationById(
            this.state.currentXfdfHighlightId
          );

          annotationManager.deleteAnnotation(annot);
        }
      });
  };

  onClickCloseVersions = () => {
    this.setState({ showingVersions: false });
  };

  onClickShowAttachments = () => {
    this.setState({ showingAttachments: true });
  };

  onClickShowReferenceDocuments = () => {
    this.setState({ showingReferences: true });
  };

  showDocumentReferencePanel = () => {
    this.setState({ showingDocumentReferences: true });
  };

  closeDocumentReferencePanel = () => {
    this.setState({ showingDocumentReferences: false });
  };

  showShareLinkPanel = () => {
    this.setState({ showShareLinkPanel: true });
  };

  showTranslationsPanel = () => {
    this.setState({ showTranslationsPanel: true });
  };

  showChatsPanel = () => {
    this.setState({ showChatsPanel: true });
  };

  showPaigeReviewPanel = () => {
    this.setState({ showPaigeReviewPanel: true });
  };

  closePaigeReviewPanel = () => {
    this.setState({ showPaigeReviewPanel: false });
  };

  handlePaigeReviewAnalysisUpdate = (analysis) => {
    if (analysis) {
      this.setState({
        paigeReviewStatus: analysis.status,
        paigeReviewCriticalCount: analysis.critical_count || 0,
        paigeReviewWarningCount: analysis.warning_count || 0,
        paigeReviewInfoCount: analysis.info_count || 0,
      });
    }
  };

  handlePaigeReviewFindingClick = (finding) => {
    if (!finding || !finding.page_number) return;

    const webViewerEl = document.getElementById("webViewer");
    const instance = window.WebViewer.getInstance(webViewerEl);

    if (!instance || !instance.Core || !instance.Core.documentViewer) return;

    const { documentViewer, annotationManager, Annotations } = instance.Core;

    // Remove previous finding highlight if exists
    if (this.paigeReviewHighlight) {
      annotationManager.deleteAnnotation(this.paigeReviewHighlight);
      this.paigeReviewHighlight = null;
    }

    // Clear any pending timeout
    if (this.paigeReviewHighlightTimeout) {
      clearTimeout(this.paigeReviewHighlightTimeout);
      this.paigeReviewHighlightTimeout = null;
    }

    // Navigate to the page
    documentViewer.setCurrentPage(finding.page_number);

    // If we have extracted text, search for it and highlight
    if (finding.extracted_text) {
      const searchMode =
        instance.Core.Search.Mode.PAGE_STOP |
        instance.Core.Search.Mode.HIGHLIGHT;

      const searchOptions = {
        fullSearch: false,
        onResult: (result) => {
          if (result.resultCode === instance.Core.Search.ResultCode.FOUND) {
            const quads = result.quads;
            const pageNum = result.pageNum;

            // Only highlight if on the correct page
            if (pageNum === finding.page_number && quads && quads.length > 0) {
              const underline = new Annotations.TextUnderlineAnnotation();
              underline.PageNumber = pageNum;
              underline.Quads = quads;
              underline.StrokeColor = new Annotations.Color(255, 193, 7); // yellow/warning color

              // Use imported: true to prevent triggering onTextSelection
              annotationManager.addAnnotation(underline, { imported: true });
              annotationManager.drawAnnotationsFromList([underline]);

              // Store reference for cleanup
              this.paigeReviewHighlight = underline;

              // Auto-remove after 5 seconds
              this.paigeReviewHighlightTimeout = setTimeout(() => {
                if (this.paigeReviewHighlight) {
                  annotationManager.deleteAnnotation(this.paigeReviewHighlight);
                  this.paigeReviewHighlight = null;
                }
              }, 5000);
            }
          }
        },
      };

      // Search for the extracted text starting from the target page
      documentViewer.textSearchInit(
        finding.extracted_text,
        searchMode,
        searchOptions
      );
    }
  };

  loadPaigeReviewFindingsCount = () => {
    var self = this;
    var docId = this.state.docId;

    // Fetch PAAB, FDA, and Illumina analyses in parallel
    Promise.all([
      paigeReviewService.getPaabAnalysesForDocument(docId).catch(function () {
        return { data: [] };
      }),
      paigeReviewService.getFdaAnalysesForDocument(docId).catch(function () {
        return { data: [] };
      }),
      paigeReviewService
        .getIlluminaAnalysesForDocument(docId)
        .catch(function () {
          return { data: [] };
        }),
    ])
      .then(function (results) {
        var paabAnalyses = results[0].data || [];
        var fdaAnalyses = results[1].data || [];
        var illuminaAnalyses = results[2].data || [];

        // Determine which analysis to use (most recent from any type)
        var candidates = [];
        if (paabAnalyses.length > 0) {
          candidates.push({ analysis: paabAnalyses[0], type: "paab" });
        }
        if (fdaAnalyses.length > 0) {
          candidates.push({ analysis: fdaAnalyses[0], type: "fda" });
        }
        if (illuminaAnalyses.length > 0) {
          candidates.push({ analysis: illuminaAnalyses[0], type: "illumina" });
        }

        if (candidates.length === 0) return;

        // Pick the most recently created analysis
        var selected = candidates.reduce(function (best, current) {
          var bestDate = new Date(best.analysis.created_at);
          var currentDate = new Date(current.analysis.created_at);
          return currentDate > bestDate ? current : best;
        });

        self.setState({
          paigeReviewStatus: selected.analysis.status,
          paigeReviewCriticalCount: selected.analysis.critical_count || 0,
          paigeReviewWarningCount: selected.analysis.warning_count || 0,
          paigeReviewInfoCount: selected.analysis.info_count || 0,
        });
      })
      .catch(function (error) {
        console.error("Error loading paige review findings count:", error);
      });
  };

  onClaimAnnotation = (claimData) => {
    this.setState({ claimData: claimData });
  };

  showClaimsPanel = () => {
    this.setState({
      showClaimsPanel: true,
      selectedClaim: null,
      showConversationsPanel: false,
      selectedBlockId: null,
      referenceBlockId: null,
      documentReferenceBlockId: null,
      documentReferenceId: null,
      showingVersions: false,
      showingAttachments: false,
      showShareLinkPanel: false,
      showTranslationsPanel: false,
      showChatsPanel: false,
      showPaigeReviewPanel: false,
      showingReferences: false,
      commentXfdfHighlightId: null,
      documentReferenceXfdfHighlightId: null,
    });
  };

  showTemplatePanel = () => {
    this.setState({
      showTemplatePanel: true,
      showClaimsPanel: false,
      selectedClaim: null,
      showConversationsPanel: false,
      selectedBlockId: null,
      referenceBlockId: null,
      documentReferenceBlockId: null,
      documentReferenceId: null,
      showingVersions: false,
      showingAttachments: false,
      showShareLinkPanel: false,
      showTranslationsPanel: false,
      showChatsPanel: false,
      showPaigeReviewPanel: false,
      showingReferences: false,
      commentXfdfHighlightId: null,
      documentReferenceXfdfHighlightId: null,
    });
  };

  hideClaimsPanel = () => {
    this.setState({
      referenceXfdfHighlightId: null,
      documentReferenceXfdfHighlightId: null,
      referenceBlockId: null,
      conversationBlockId: null,
      commentXfdfHighlightId: null,
      currentXfdfHighlightPageIndex: null,
      currentXfdfHighlightId: null,
      currentXfdfHighlightString: null,
      showClaimsPanel: false,
      selectedClaim: null,
    });
  };

  showLinkClaimPanel = () => {
    this.setState({
      showLinkClaimPanel: true,
      showClaimsPanel: true,
      selectedClaim: null,
    });
  };

  setSelectedClaim = (claim) => {
    this.setState({ selectedClaim: claim });
  };

  hideLinkClaimPanel = () => {
    if (!this.state.selectedClaim) {
      const webViewerEl = document.getElementById("webViewer");
      const annotationManager =
        window.WebViewer.getInstance(webViewerEl).Core.annotationManager;
      const annot = annotationManager.getAnnotationById(
        this.state.currentXfdfHighlightId
      );

      annotationManager.deleteAnnotation(annot);
    }

    this.setState({ showLinkClaimPanel: false });
  };

  hideTemplatePanel = () => {
    this.setState({ showTemplatePanel: false });
  };

  closeShareLinkPanel = () => {
    this.setState({ showShareLinkPanel: false });
  };

  closeTranslationsPanel = () => {
    this.setState({ showTranslationsPanel: false });
  };

  closeChatsPanel = () => {
    this.setState({ showChatsPanel: false });
  };

  handleChatSessionChange = (sessionId) => {
    this.setState({ currentChatSessionId: sessionId });
  };

  handlePaigeStatusChange = (newStatus) => {
    this.setState({
      document: {
        ...this.state.document,
        paige_status: newStatus,
      },
    });
  };

  handleChatCitationClick = (citation) => {
    if (!citation || !citation.page || !citation.page.page_number) return;

    const { page, text } = citation;
    const webViewerEl = document.getElementById("webViewer");
    const instance = window.WebViewer.getInstance(webViewerEl);

    if (!instance || !instance.Core || !instance.Core.documentViewer) return;

    const { documentViewer, annotationManager, Annotations } = instance.Core;

    // Set flag to prevent onTextSelection from closing the chats panel
    this.isCitationSearch = true;

    // Remove previous citation highlight if exists
    if (this.chatCitationHighlight) {
      annotationManager.deleteAnnotation(this.chatCitationHighlight);
      this.chatCitationHighlight = null;
    }

    // Clear any pending timeout
    if (this.chatCitationTimeout) {
      clearTimeout(this.chatCitationTimeout);
      this.chatCitationTimeout = null;
    }

    // Navigate to the page
    documentViewer.setCurrentPage(page.page_number);

    // If we have citation text, search for it and underline
    if (text) {
      const searchMode =
        instance.Core.Search.Mode.PAGE_STOP |
        instance.Core.Search.Mode.HIGHLIGHT;

      const searchOptions = {
        fullSearch: false,
        onResult: (result) => {
          // Clear the citation search flag
          this.isCitationSearch = false;

          if (result.resultCode === instance.Core.Search.ResultCode.FOUND) {
            const quads = result.quads;
            const pageNum = result.pageNum;

            // Only highlight if on the correct page
            if (pageNum === page.page_number && quads && quads.length > 0) {
              const underline = new Annotations.TextUnderlineAnnotation();
              underline.PageNumber = pageNum;
              underline.Quads = quads;
              underline.StrokeColor = new Annotations.Color(255, 193, 7); // yellow/warning color

              // Use imported: true to prevent triggering onTextSelection
              annotationManager.addAnnotation(underline, { imported: true });
              annotationManager.drawAnnotationsFromList([underline]);

              // Store reference for cleanup
              this.chatCitationHighlight = underline;

              // Auto-remove after 5 seconds
              this.chatCitationTimeout = setTimeout(() => {
                if (this.chatCitationHighlight) {
                  annotationManager.deleteAnnotation(
                    this.chatCitationHighlight
                  );
                  this.chatCitationHighlight = null;
                }
              }, 5000);
            }
          }
        },
      };

      // Search for the citation text starting from the target page
      documentViewer.textSearchInit(text, searchMode, searchOptions);
    } else {
      // No text to search, clear the flag after a short delay
      setTimeout(() => {
        this.isCitationSearch = false;
      }, 100);
    }
  };

  onStartLinkingReferences = () => {
    this.setState({ linkingReferences: true });
  };

  onStopLinkingReferences = () => {
    this.setState({ linkingReferences: false });
  };

  onClickCloseAttachments = () => {
    this.setState({ showingAttachments: false });
  };

  onClickCloseReferenceDocumentPanel = () => {
    this.setState({ showingReferences: false });
  };

  updateSelectedCommentId = (commentId) => {
    this.setState({ selectedCommentId: commentId });
    let baseURL = this.props.location.pathname.replace(
      /^(\/[^/]*\/[^/]*).*/,
      "$1"
    );
    history.replace(
      `${baseURL}?xfdfId=${
        this.state.currentXfdfHighlightId || this.state.conversationBlockId
      }${commentId ? `&commentId=${commentId}` : ``}`
    );
  };

  updateApprovalsRemaining = (pending_approvals) => {
    this.setState({
      document: {
        ...this.state.document,
        pending_approvals,
      },
    });
  };

  updateApproval = (approval) => {
    this.setState({
      approval,
    });
  };

  uploadNewFile = () => {
    httpClient
      .delete(`/documents/${this.state.docId}.json`)
      .then(() => history.push("/drafts/upload"));
  };

  backToPreviousVersion = () => {
    let currentVersion = this.state.docId;
    httpClient
      .delete(`/documents/version/${currentVersion}.json`)
      .then((response) => {
        let currentVersionCount = this.state.versionCount - 1;
        let versions = this.state.versions.filter((version) => {
          return version.id !== currentVersion;
        });
        history.push(`/drafts/${versions[0].id}`);
        this.setState(
          {
            versionId: null,
            versionNumber: null,
            readOnly: false,
            versionDocument: null,
            versionCount: currentVersionCount,
            versions,
            docId: versions[0].id,
            document: versions[0],
          },
          () => {
            if (
              this.state.document.not_pdftron ||
              this.state.document.is_video
            ) {
              this.loadDocument(this.state.docId);
            } else {
              this.handleVersionLoad(
                this.state.docId,
                this.state.document.file_extension
              );
            }
          }
        );
      });
  };

  uploadNewDocumentVersion = () => {
    let currentVersion = this.state.docId;
    httpClient
      .delete(`/documents/version/${currentVersion}.json`)
      .then((response) => {
        let currentVersionCount = this.state.versionCount - 1;
        let versions = this.state.versions.filter((version) => {
          return version.id !== currentVersion;
        });
        history.push(`/drafts/${versions[0].id}/update_video`);
      });
  };

  handleChangeCreatableSelect = (newValue: any, actionMeta: any) => {
    const newDocumentState = this.state.document;
    const tagsCheck = {};
    let tagsList = [];

    if (newValue) {
      newValue.forEach((tag) => {
        if (!tagsCheck[tag["value"].toLowerCase()]) {
          // Add it to the tag list
          tagsList.push(tag.value);
          tagsCheck[tag["value"].toLowerCase()] = true;
        }
      });
    }

    newDocumentState.tags_list = tagsList;

    this.setState({
      document: newDocumentState,
      creatableSelectTagsList: newValue,
    });
  };

  lockDownCommentsReferencesVersions = () => {
    // Check if the document is approved and if the currentUser is
    // a document owner or Admin
    const owner =
      this.state.document.uploaded_by_user_id === this.state.currentUser.id;
    const approved = this.state.document.approved;
    const admin = this.state.currentUser.role === "admin";

    return (approved && (owner || admin)) || !approved ? false : true;
  };

  ownerAdminOrAuthorUser = () => {
    if (
      this.state.currentUser.role === "admin" ||
      this.state.currentUser.role === "author"
    ) {
      return true;
    } else if (
      this.state.document.uploaded_by_user_id === this.state.currentUser.id
    ) {
      return true;
    } else {
      return false;
    }
  };

  renderErrorDocument = () => {
    if (this.state.versions.length > 0) {
      return (
        <Col sm={12} className={styles.documentContainer}>
          <div
            className={`${styles.header} ${
              document.not_pdftron ? styles.headerLegacy : ""
            }`}
            id="document_view_header"
          >
            <span>
              <Uikon>
                <Link to={"/dashboard"} className={styles.backLink}>
                  arrow_left
                </Link>
              </Uikon>
            </span>
            {this.state.document.title}
          </div>
          <div className={styles.processingError}>
            <img src={Warning} className={styles.warning} />
            <div className={styles.heading}>
              There was an error processing your file
            </div>
            {this.state.versions.length === 1 ? (
              <div className={styles.processingErrorButtons}>
                <ButtonPrimary
                  onClick={this.deleteAllVersions}
                  transparent
                  text="Delete"
                />
                <ButtonPrimary
                  onClick={this.uploadNewFile}
                  className={styles.processingErrorUploadButton}
                  original
                  text="Upload new file"
                />
              </div>
            ) : (
              <div className={styles.processingErrorButtons}>
                <ButtonPrimary
                  onClick={this.uploadNewDocumentVersion}
                  className={styles.processingErrorUploadButton}
                  transparent
                  text="Upload new version"
                />
                <ButtonPrimary
                  onClick={this.backToPreviousVersion}
                  className={styles.processingErrorPreviousVersionButton}
                  original
                  text="Back to previous version"
                />
              </div>
            )}
          </div>
        </Col>
      );
    }
  };

  renderDocument = (document) => {
    if (document.document_state_code == "processing") {
      return (
        <div className={styles.documentMessageContainer}>
          <div className={styles.documentMessageContainerIcon}>
            <img src={clockIcon} alt="processing icon" />
          </div>
          <div className={styles.documentMessageContainerMessage}>
            Your file is processing...
          </div>
        </div>
      );
    } else if (
      this.state.docId &&
      document &&
      this.state.conversations &&
      !document.is_video &&
      !document.not_pdftron &&
      this.state.referencesLoaded
    ) {
      let docExtension = document.file_extension;
      if (this.state.versionId) {
        let version = this.state.versions.find(
          (version) => version.id == this.state.versionId
        );
        docExtension = version.file_extension;
      }
      return (
        <PDFDocument
          setCurrentAnnotationText={this.setCurrentAnnotationText}
          setAnnotationsLoaded={this.setAnnotationsLoaded}
          inRedefineMode={this.state.inRedefineMode}
          editingDocumentReferences={this.state.editingDocumentReferences}
          setUpdatedXFDF={this.setUpdatedXFDF}
          setRedefineMode={this.setRedefineMode}
          inRedefineMode={this.state.inRedefineMode}
          closeDocumentReferencePanel={this.closeDocumentReferencePanel}
          hideAllAnnotations={this.state.hideAllAnnotations}
          hideComments={this.state.hideComments}
          hideReferences={this.state.hideReferences}
          hideClaims={this.state.hideClaims}
          hideNativeAnnotations={this.state.hideNativeAnnots}
          setClaimToLink={this.setClaimToLink}
          onClaimAnnotation={this.onClaimAnnotation}
          showLinkClaimPanel={this.showLinkClaimPanel}
          hideClaimsPanel={this.hideClaimsPanel}
          hideLinkClaimPanel={this.hideLinkClaimPanel}
          hideTemplatePanel={this.hideTemplatePanel}
          newAnnotationHighlightXfdfId={this.state.newAnnotationHighlightXfdfId}
          doc={document}
          docId={this.state.docId}
          libraryId={this.state.document.library_id}
          docExtension={docExtension}
          versionId={parseInt(this.state.versionId)}
          onTextSelection={this.onTextSelection}
          onAnnotationSelect={this.onAnnotationSelect}
          onAnnotationDeselect={this.onAnnotationDeselect}
          isApproved={document.approved}
          addAnnotation={this.addAnnotation}
          closeConversation={this.onClosePDFDocumentConversation}
          onCloseConversation={this.onCloseConversation}
          openReferenceDocumentPanel={this.onClickShowReferenceDocuments}
          linkingReferences={this.onStartLinkingReferences}
          closeReferenceDocumentPanel={this.onClickCloseReferenceDocumentPanel}
          closeAttachmentsPanel={this.onClickCloseAttachments}
          queryXfdfId={this.state.queryXfdfId}
          deleteDocumentReference={this.deleteDocumentReference}
          addStampImageToPinReferences={this.addStampImageToPinReferences}
          confirmReferencesLoaded={this.confirmReferencesLoaded}
          // references={
          //   this.props.documentReferences &&
          //   this.addStampImageToPinReferences(this.props.documentReferences)
          // }
          claims={this.props.claims}
          readOnly={this.state.readOnly}
          convoStatusToggled={this.state.convoStatusToggled}
          resetConversationStatusToggle={this.resetConversationStatusToggle}
          updateConvos={this.state.updateConvos}
          updateSavingContentState={this.updateSavingContentState}
          formFieldValues={this.state.formFieldValues}
          updateFormFieldValues={(formFieldValues) =>
            this.setState({ formFieldValues })
          }
          signatures={this.state.signatures}
          setSelectedSignature={this.setSelectedSignature}
          loadSignatures={this.loadSignatures}
          lockDownCRV={this.lockDownCommentsReferencesVersions()}
          claimToLink={this.state.claimToLink}
          setcreatedClaim={this.setSelectedClaim}
          closelinkClaimPanel={this.hideLinkClaimPanel}
          templateKeys={this.state.templateKeys}
          templateKeysSchema={this.state.templateKeysSchema}
          setTemplateKeys={this.setTemplateKeys}
          documentDynamicFields={this.props.documentDynamicFields}
          createdFromTemplate={this.state.document.document_template_id}
          setConversationsInitiated={this.setConversationsInitiated}
          conversationsInitiated={this.state.conversationsInitiated}
          setPreviousConvoId={this.setPreviousConvoId}
          loadDocument={this.loadDocument}
        />
      );
    } else if (!document.is_video && document.not_pdftron) {
      return (
        <Document
          doc={document}
          versionId={this.state.versionId}
          loadConversation={this.onClickedConversationIndicator}
          loadReference={this.onClickedReferenceIndicator}
          highlightedBlock={this.onHighlightedBlock}
          readOnly={this.state.readOnly}
          versionId={this.state.versionId}
          versionNumber={this.state.versionNumber}
        />
      );
    } else if (document.is_video) {
      return (
        <VideoApp
          doc={document}
          versionId={this.state.versionId}
          loadConversation={this.onClickedConversationIndicator}
          loadReference={this.onClickedReferenceIndicator}
          highlightedBlock={this.onHighlightedBlock}
          readOnly={this.state.readOnly}
          versionId={this.state.versionId}
          versionNumber={this.state.versionNumber}
          documentContainer={this.documentContainer}
        />
      );
    }
  };

  isEditable = (mimeType) => {
    console.log("this.state.document.mime_type", this.state.document.mime_type);
    let editable = false;
    if (
      mimeType === "application/vnd.ms-excel" ||
      mimeType === "application/vnd.ms-powerpoint" ||
      mimeType === "application/msword" ||
      mimeType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      mimeType ===
        "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
      mimeType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      editable = true;
    }

    if (this.state.document && this.state.document.approved) {
      editable = false;
    }

    return editable;
  };

  renderSidePanel = (document) => {
    let numConversations = 0;

    if (this.state.conversations) {
      const generalCommentsConversation = this.state.conversations.find(
        (conversation) => conversation.block_identifier
      );
      numConversations = this.state.conversations.length;
      if (generalCommentsConversation) {
        if (generalCommentsConversation.comments.length === 0) {
          numConversations--;
        }
      }
    }

    return (
      <div>
        {this.state.selectedBlockId !== null && (
          <SelectedTextPanel
            selectConversation={this.onConversationSelection}
            selectReference={this.onReferenceSelection}
            selectedBlockId={this.state.selectedBlockId}
            close={this.onCloseSelectedTextPanel}
            pageNumber={this.state.conversationPageNumber}
            docId={this.state.document.id}
          />
        )}
        {/*</CSSTransitionGroup>*/}
        <div className={styles.notCommentPanel}>
          {!this.lockDownCommentsReferencesVersions() &&
            this.state.document.approved && (
              <div className={styles.approvedAndOwnerOrAdmin}>
                <div className={styles.approvedAndOwnerOrAdminText}>
                  You can see all details on this approved content
                </div>
                <div className={styles.toolTipContainer}>
                  <div className={styles.refIdTooltipBox}>
                    <Tooltip
                      type="approved-description"
                      subType="approvedContent"
                    />
                  </div>
                </div>
              </div>
            )}
          {this.state.conversationBlockId === null &&
            this.state.referenceBlockId === null &&
            this.state.documentReferenceBlockId === null &&
            this.state.selectedBlockId === null &&
            (this.state.currentXfdfHighlightId === null ||
              this.state.strikeoutJustAdded) &&
            !this.state.showingVersions &&
            !this.state.showingAttachments &&
            !this.state.showingReferences && (
              <ApprovalsSection
                documentDetails={this.state.document}
                approval={this.state.approval}
                readOnly={this.state.readOnly}
                versionId={this.state.versionId}
                versionNumber={this.state.versionNumber}
              />
            )}
          {this.state.conversationBlockId === null &&
            this.state.referenceBlockId === null &&
            this.state.selectedBlockId === null &&
            (this.state.currentXfdfHighlightId === null ||
              this.state.strikeoutJustAdded) &&
            this.state.documentReferenceBlockId === null &&
            this.state.approval &&
            this.state.approval.id &&
            !this.state.approval.observer &&
            !this.state.showingVersions &&
            !this.state.showingAttachments &&
            !this.state.showingReferences &&
            !this.state.document.approved && (
              <div className={styles.approvalCardContainer}>
                <div
                  className={`${styles.sidePanelOptions} ${styles.sidePanelOptionsMyApproval}`}
                >
                  <ApprovalCard
                    approval={this.state.approval}
                    readOnly={this.state.readOnly}
                    updateApprovalsRemaining={this.updateApprovalsRemaining}
                    updateApproval={this.updateApproval}
                  />
                </div>
                <div className={styles.divider}></div>
              </div>
            )}

          {accountSetting.getSetting("papercurve_office") === "TRUE" &&
            this.isEditable(this.state.document.mime_type) && (
              <SidePanelSection
                clickAction={this.onClickEditor}
                type={"editor"}
              />
            )}

          {accountSetting.getSetting("paige_translations") === "TRUE" &&
            !this.state.document.is_video &&
            !this.state.versionId && (
              <SidePanelSection
                clickAction={this.showTranslationsPanel}
                count={this.getNumberTranslations()}
                type={"paige_translations"}
              />
            )}

          {!this.state.document.is_video && !this.state.versionId && (
            <SidePanelSection
              clickAction={this.showChatsPanel}
              type={"chats"}
            />
          )}

          {!this.state.document.is_video &&
            !this.state.versionId &&
            this.state.paigeReviewStatus && (
              <SidePanelSection
                clickAction={this.showPaigeReviewPanel}
                type={"paige_review"}
                paigeReviewStatus={this.state.paigeReviewStatus}
                criticalCount={this.state.paigeReviewCriticalCount}
                warningCount={this.state.paigeReviewWarningCount}
                infoCount={this.state.paigeReviewInfoCount}
              />
            )}

          {!this.lockDownCommentsReferencesVersions() &&
            this.state.selectedBlockId == null &&
            (this.state.currentXfdfHighlightId === null ||
              this.state.strikeoutJustAdded) &&
            this.state.conversationBlockId === null &&
            this.state.documentReferenceBlockId === null &&
            this.state.referenceBlockId === null &&
            !this.state.showingVersions &&
            !this.state.showingAttachments &&
            !this.state.showingReferences && (
              <SidePanelSection
                clickAction={
                  !document.is_video
                    ? this.onClickShowConversationsPanel
                    : this.onClickShowGeneralComments
                }
                type={"comments"}
                count={numConversations}
              />
            )}

          {!this.lockDownCommentsReferencesVersions() &&
            this.state.selectedBlockId == null &&
            (this.state.currentXfdfHighlightId === null ||
              this.state.strikeoutJustAdded) &&
            this.state.documentReferenceBlockId === null &&
            this.state.conversationBlockId === null &&
            this.state.referenceBlockId === null &&
            !this.state.showingVersions &&
            !this.state.showingAttachments &&
            !this.state.showingReferences && (
              <SidePanelSection
                clickAction={this.onClickShowVersions}
                type={"versions"}
                count={this.state.versions.length}
              />
            )}
          {!this.state.showingVersions &&
            !this.state.showingAttachments &&
            !this.state.showingReferences && (
              <SidePanelSection
                clickAction={this.onClickShowAttachments}
                type={"attachments"}
                count={this.state.attachments.length}
              />
            )}

          {!this.lockDownCommentsReferencesVersions() &&
            this.state.annotationsLoaded &&
            this.state.selectedBlockId == null &&
            (this.state.currentXfdfHighlightId === null ||
              this.state.strikeoutJustAdded) &&
            this.state.conversationBlockId === null &&
            this.state.documentReferenceBlockId === null &&
            this.state.referenceBlockId === null &&
            !this.state.showingVersions &&
            !this.state.showingAttachments &&
            !this.state.showingReferences &&
            this.state.docRefsLoadedInMainDoc && (
              <SidePanelSection
                clickAction={this.showDocumentReferencePanel}
                count={this.state.numReferences}
                type={"references"}
              />
            )}
          {accountSetting.getSetting("share_link") === "TRUE" &&
            !this.state.versionId && (
              <SidePanelSection
                clickAction={this.showShareLinkPanel}
                count={this.getNumberShareLinks()}
                type={"share_link"}
              />
            )}

          {!this.state.showingVersions &&
            !this.state.showingAttachments &&
            !this.state.showingReferences && (
              <SidePanelSection
                clickAction={this.showClaimsPanel}
                count={
                  this.props.claims &&
                  this.props.documentClaims &&
                  this.props.claims.length + this.props.documentClaims.length
                }
                type={"claims"}
              />
            )}

          {!this.state.showingVersions &&
            !this.state.showingAttachments &&
            !this.state.showingReferences &&
            (this.state.templateKeys.length > 0 ||
              (this.props.documentDynamicFields &&
                this.props.documentDynamicFields.length > 0)) &&
            this.ownerAdminOrAuthorUser() && (
              <SidePanelSection
                clickAction={this.showTemplatePanel}
                count={
                  this.props.claims &&
                  this.props.documentClaims &&
                  this.props.claims.length + this.props.documentClaims.length
                }
                type={"template"}
              />
            )}

          {this.state.conversationBlockId === null &&
            this.state.referenceBlockId === null &&
            this.state.documentReferenceBlockId === null &&
            this.state.selectedBlockId === null &&
            (this.state.currentXfdfHighlightId === null ||
              this.state.strikeoutJustAdded) &&
            !this.state.showingAttachments &&
            !this.state.showingReferences &&
            this.state.currentUser.role == "viewer" && (
              <ContentPropertiesSection
                renderOwnerName={this.renderOwnerName}
                renderDocumentFieldValues={this.renderDocumentFieldValues}
                renderDocumentTagValues={this.renderDocumentTagValues}
                documentDetails={this.state.document}
                renderLibraryName={this.renderLibraryName}
                viewer={true}
              />
            )}

          {this.state.conversationBlockId === null &&
            this.state.referenceBlockId === null &&
            this.state.documentReferenceBlockId === null &&
            this.state.selectedBlockId === null &&
            (this.state.currentXfdfHighlightId === null ||
              this.state.strikeoutJustAdded) &&
            !this.state.showingVersions &&
            !this.state.showingAttachments &&
            !this.state.showingReferences &&
            this.state.currentUser.role !== "viewer" && (
              <ContentPropertiesSection
                showContentDetailsModal={this.showContentDetailsModal}
                renderOwnerName={this.renderOwnerName}
                renderDocumentFieldValues={this.renderDocumentFieldValues}
                renderDocumentTagValues={this.renderDocumentTagValues}
                documentDetails={this.state.document}
                renderLibraryName={this.renderLibraryName}
                viewer={false}
              />
            )}
        </div>
      </div>
    );
  };

  checkForNonVideoVersions = (versions) => {
    let nonVideoVersionCount = 0;
    versions.map((version) => {
      if (!version.is_video) {
        nonVideoVersionCount += 1;
      }
    });
    if (nonVideoVersionCount >= 2) {
      return true;
    } else {
      return false;
    }
  };

  showPapercurveAnnotationsToggles = () => {
    if (this.state.readOnly) {
      if (this.state.currentUser.role === "admin") {
        return true;
      } else if (
        this.state.currentUser.role === "author" &&
        this.state.document.uploaded_by_user_id === this.state.currentUser.id
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  checkCanUploadNewVersion = () => {
    return (
      this.state.currentUser.role === "admin" ||
      this.state.currentUser.role === "author"
    );
  };

  selectAnnotationLayer = () => {
    if (this.state.annotLayersClicked) {
      this.setState({ annotLayersClicked: false });
    } else {
      this.setState({ annotLayersClicked: true });
    }
  };

  hideAllAnnots = () => {
    if (
      this.state.hideAllAnnotations ||
      (this.state.hideComments &&
        this.state.hideReferences &&
        this.state.hideClaims)
    ) {
      this.setState({
        hideAllAnnotations: false,
        hideComments: false,
        hideReferences: false,
        hideClaims: false,
      });
    } else {
      this.setState({
        hideAllAnnotations: true,
        hideComments: true,
        hideReferences: true,
        hideClaims: true,
      });
    }
  };

  hideAllComments = () => {
    if (this.state.hideComments) {
      this.setState({ hideComments: false });
    } else {
      this.setState({ hideComments: true });
    }
  };

  hideAllReferences = () => {
    if (this.state.hideReferences) {
      this.setState({ hideReferences: false });
    } else {
      this.setState({ hideReferences: true });
    }
  };

  hideNativeAnnotations = () => {
    if (this.state.hideNativeAnnots) {
      this.setState({ hideNativeAnnots: false });
    } else {
      this.setState({ hideNativeAnnots: true });
    }
  };

  hideAllClaims = () => {
    if (this.state.hideClaims) {
      this.setState({ hideClaims: false });
    } else {
      this.setState({ hideClaims: true });
    }
  };

  getQueryStringValue = (key) => {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i"
        ),
        "$1"
      )
    );
  };

  setTemplateKeys = (keys, schema) => {
    console.log("!!keys", keys);
    console.log("!!schema", schema);
    this.setState({ templateKeys: keys, templateKeysSchema: schema });
  };

  getAllPapercurveCheckedStatus = () => {
    if (
      !this.state.hideComments &&
      !this.state.hideReferences &&
      !this.state.hideClaims
    ) {
      return true;
    } else if (
      this.state.hideComments ||
      this.state.hideReferences ||
      this.state.hideClaims
    ) {
      return false;
    } else {
      return !this.state.hideAllAnnotations;
    }
  };

  render() {
    const { getFieldError, getFieldDecorator } = this.props.form;
    let document = this.state.document;
    if (this.state.versionId && this.state.versionDocument) {
      document = this.state.versionDocument;
    }

    const actionsDropDown = ({ onClick }) => {
      return (
        <div
          className={styles.documentActionsDropDownContainer}
          onClick={onClick}
        >
          &#9679;&#9679;&#9679;
        </div>
      );
    };

    const annotationLayersDropDown = ({ onClick }) => {
      return (
        <div
          className={styles.annotaionLayersDropDownContainer}
          onClick={onClick}
        >
          <UikButton className={styles.exportButton}>
            <img className={styles.layersIcon} src={AnnotationLayersIcon} />
            Annotations
          </UikButton>
        </div>
      );
    };

    return (
      <React.Fragment>
        <Container fluid className={styles.documentViewer}>
          <Header latestApproved={this.state.latestApproved} />
          {Object.keys(document).length > 0 ? (
            <Row>
              {document.document_state_code === "error" ? (
                this.renderErrorDocument()
              ) : (
                <React.Fragment>
                  <Col
                    sm={9}
                    className={`${styles.documentContainer} ${
                      this.state.showChatsPanel ||
                      this.state.showPaigeReviewPanel
                        ? styles.documentContainerChatOpen
                        : ""
                    }`}
                    ref={(element) => {
                      this.documentContainer = element;
                    }}
                    id="document_container"
                  >
                    <div
                      className={`${styles.header} ${
                        document.not_pdftron ? styles.headerLegacy : ""
                      }`}
                      id="document_view_header"
                    >
                      <div className={styles.leftContainer}>
                        <div
                          onClick={() => this.handleGoBack()}
                          className={styles.backLink}
                        >
                          <img src={BackArrowIcon} />
                        </div>
                        <div className={styles.title}>
                          {this.state.document.title}
                        </div>
                        {this.renderVersionMessage()}
                      </div>
                      {!this.state.editingDocumentReferences && (
                        <div className={styles.rightContainer}>
                          <div
                            onClick={() => {
                              this.selectAnnotationLayer();
                            }}
                            className={styles.annotaionLayersDropDownContainer}
                          >
                            {document.document_state_code == "ready" && (
                              <UikDropdown
                                DisplayComponent={annotationLayersDropDown}
                                position="bottomRight"
                              >
                                <UikDropdownItem>
                                  Annotation Layers
                                </UikDropdownItem>
                                <UikDropdownItem>
                                  <UikToggle
                                    disabled={false}
                                    defaultChecked={true}
                                    checked={!this.state.hideNativeAnnots}
                                    onChange={() =>
                                      this.hideNativeAnnotations()
                                    }
                                  />
                                  Imported Annotations
                                </UikDropdownItem>
                                {this.showPapercurveAnnotationsToggles() && (
                                  <UikDropdownItem>
                                    <UikToggle
                                      disabled={false}
                                      defaultChecked={true}
                                      checked={this.getAllPapercurveCheckedStatus()}
                                      onChange={() => this.hideAllAnnots()}
                                    />
                                    All Papercurve
                                  </UikDropdownItem>
                                )}
                                {this.showPapercurveAnnotationsToggles() && (
                                  <UikDropdownItem>
                                    <UikToggle
                                      disabled={false}
                                      defaultChecked={true}
                                      checked={!this.state.hideComments}
                                      onChange={() => this.hideAllComments()}
                                    />
                                    Comments
                                  </UikDropdownItem>
                                )}
                                {this.showPapercurveAnnotationsToggles() && (
                                  <UikDropdownItem>
                                    <UikToggle
                                      disabled={false}
                                      defaultChecked={true}
                                      checked={!this.state.hideReferences}
                                      onChange={() => this.hideAllReferences()}
                                    />
                                    References
                                  </UikDropdownItem>
                                )}
                                <UikDropdownItem>
                                  <UikToggle
                                    disabled={false}
                                    defaultChecked={true}
                                    checked={!this.state.hideClaims}
                                    onChange={() => this.hideAllClaims()}
                                  />
                                  Product Claims
                                </UikDropdownItem>
                              </UikDropdown>
                            )}
                          </div>
                          <div className={styles.documentActionsDropDown}>
                            {document.document_state_code == "ready" && (
                              <UikDropdown
                                DisplayComponent={actionsDropDown}
                                position="bottomRight"
                              >
                                <UikDropdownItem
                                  onClick={(e) => {
                                    this.state.savingContentState
                                      ? this.handleDownloadPDFWithComments(e)
                                      : this.handleDownloadModal(e);
                                  }}
                                >
                                  Download
                                </UikDropdownItem>

                                {this.state.formats.map((format, idx) => {
                                  return (
                                    <UikDropdownItem
                                      onClick={(e) =>
                                        this.handleFormatDownload(e, format)
                                      }
                                    >
                                      Download {format.extension}
                                    </UikDropdownItem>
                                  );
                                })}

                                {(this.state.currentUser.role === "admin" ||
                                  this.state.currentUser.role === "author") && (
                                  <UikDropdownItem
                                    onClick={(e) => this.handleDelete(e)}
                                  >
                                    Delete
                                  </UikDropdownItem>
                                )}
                                {(this.state.currentUser.role === "admin" ||
                                  this.state.currentUser.role === "author") &&
                                  !this.state.document.approved && (
                                    <UikDropdownItem
                                      onClick={(e) =>
                                        this.handleOpenRenameModal(e)
                                      }
                                    >
                                      Rename
                                    </UikDropdownItem>
                                  )}
                                {this.checkCanUploadNewVersion() &&
                                  !this.state.document.approved &&
                                  !this.state.document.is_video && (
                                    <UikDropdownItem
                                      onClick={this.uploadNewVersion}
                                    >
                                      Upload new version
                                    </UikDropdownItem>
                                  )}
                                {this.checkCanUploadNewVersion() &&
                                  !this.state.document.approved &&
                                  this.state.document.is_video && (
                                    <UikDropdownItem>
                                      <Link
                                        className={styles.uploadNewVersionLink}
                                        to={`/drafts/${this.state.document.id}/update_video`}
                                      >
                                        Upload new version
                                      </Link>
                                    </UikDropdownItem>
                                  )}
                              </UikDropdown>
                            )}
                          </div>
                          {this.state.savingContentState &&
                            !this.state.readOnly && (
                              <div className={styles.savingContentContainer}>
                                <div className={styles.text}>
                                  {this.state.savingContentState.text}
                                </div>
                                <div className={styles.icon}>
                                  <img
                                    className={
                                      this.state.savingContentState.icon !==
                                        CloudCheckmark && styles.hidden
                                    }
                                    src={CloudCheckmark}
                                  />
                                  <img
                                    className={
                                      this.state.savingContentState.icon !==
                                        SavingSpinningArrows && styles.hidden
                                    }
                                    src={SavingSpinningArrows}
                                  />
                                  <img
                                    className={
                                      this.state.savingContentState.icon !==
                                        CloudBadConnection && styles.hidden
                                    }
                                    src={CloudBadConnection}
                                  />
                                  {this.state.savingContentState.icon ===
                                    CloudCheckmark && (
                                    <div
                                      className={styles.formChangesSavedTooltip}
                                    >
                                      <img
                                        className={styles.dimpleIcon}
                                        src={DimpleSVG}
                                      />
                                      <div className={styles.tooltipText}>
                                        All changes saved
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                        </div>
                      )}
                    </div>
                    {this.state.editingDocumentReferences && (
                      <div className={styles.editModeContainer}>
                        <img className={styles.editIcon} src={editIconOrange} />
                        <p>Editing Mode</p>
                      </div>
                    )}

                    {window.document.getElementById("document_container")
                      ? this.renderDocument(document)
                      : null}
                  </Col>
                  {this.state.referenceBlockId == null &&
                    this.state.referenceXfdfHighlightId == null &&
                    this.state.documentReferenceBlockId == null &&
                    this.state.documentReferenceXfdfHighlightId == null &&
                    this.state.conversationBlockId === null &&
                    this.state.commentXfdfHighlightId === null &&
                    this.state.showingAttachments === false &&
                    this.state.showingReferences === false &&
                    this.state.showingVersions === false && (
                      <Col
                        sm={3}
                        className={styles.sidePanelContainer}
                        ref={this.sidePanelContainerCallback}
                        id="sidePanelContainer"
                      >
                        <div
                          className={
                            this.state.selectedBlockId ||
                            this.state.currentXfdfHighlightId ||
                            this.state.referenceBlockId ||
                            this.state.documentReferenceBlockId ||
                            (this.state.conversationBlockId &&
                            this.state.strikeoutComment != true
                              ? styles.sidePanelSelectedText
                              : styles.sidePanel)
                          }
                        >
                          {document.document_state_code == "ready"
                            ? this.renderSidePanel(document)
                            : ""}
                        </div>
                      </Col>
                    )}
                  <CSSTransition
                    in={this.state.showConversationsPanel}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <ConversationsPanel
                      conversations={this.state.conversations}
                      commentorUsers={this.generateCommentorUsers()}
                      closeConversationsPanel={this.onCloseConversationsPanel}
                      showGeneralComments={this.onClickShowGeneralComments}
                      showAnnotationComments={this.onAnnotationSelect}
                      reloadConversations={this.loadConversations}
                      readOnly={this.state.readOnly}
                      toggleStatus={this.toggleStatus}
                      docId={this.state.document.id}
                      versionId={this.state.versionId}
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={
                      (this.props.referenceDocuments &&
                        (this.state.referenceBlockId !== null ||
                          this.state.referenceXfdfHighlightId !== null ||
                          this.state.documentReferenceBlockId !== null ||
                          this.state.documentReferenceXfdfHighlightId !==
                            null)) ||
                      this.state.inRedefineMode
                    }
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <GroupedDocumentReferencesPanel
                      currentAnnotationText={this.state.currentAnnotationText}
                      setCurrentAnnotationText={this.setCurrentAnnotationText}
                      hideAllAnnots={this.hideAllAnnots}
                      setUpdatedXFDF={this.setUpdatedXFDF}
                      startEditingDocumentReferences={
                        this.startEditingDocumentReferences
                      }
                      stopEditingDocumentReferences={
                        this.stopEditingDocumentReferences
                      }
                      setRedefineMode={this.setRedefineMode}
                      inRedefineMode={this.state.inRedefineMode}
                      redefinedXFDF={this.state.redefinedXFDF}
                      redefinedXFDFId={this.state.redefinedXFDFId}
                      showDocumentReferencePanel={
                        this.showDocumentReferencePanel
                      }
                      key={this.state.referenceBlockId}
                      referenceBlockId={
                        this.state.referenceBlockId ||
                        this.state.documentReferenceBlockId
                      }
                      referenceXfdfHighlightId={
                        this.state.referenceXfdfHighlightId ||
                        this.state.documentReferenceXfdfHighlightId
                      }
                      close={this.onCloseGroupedDocumentReferencesPanel}
                      pageNumber={this.state.referencePageNumber}
                      docId={document.id}
                      isApproved={document.approved}
                      readOnly={this.state.readOnly}
                      versionId={this.state.versionId}
                      versionNumber={this.state.versionNumber}
                      originalDocumentId={this.state.document.id}
                      legacyDocument={document.not_pdftron}
                      referenceDocuments={this.props.referenceDocuments}
                      setDocumentReferenceId={this.setDocumentReferenceId}
                      showReferencesLibrary={() =>
                        this.setState({ showReferencesLibrary: true })
                      }
                      linkingReference={this.state.linkingReferences}
                      linkExistingAnnotation={this.linkExistingAnnotation}
                      onAddToReference={this.onAddToReference}
                      library={this.state.document.library}
                      viewingCurrentVersion={
                        !this.state.versionId ||
                        (this.state.versionId &&
                          this.state.versionId === this.state.docId)
                      }
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={
                      this.state.conversationBlockId !== null &&
                      !this.state.downloadingFile
                    }
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <CommentPanel
                      key={this.state.conversationBlockId}
                      setConversationsInitiated={this.setConversationsInitiated}
                      conversationsInitiated={this.state.conversationsInitiated}
                      conversationBlockId={this.state.conversationBlockId}
                      closeConversation={this.onCloseConversation}
                      pageNumber={this.state.conversationPageNumber}
                      docId={document.id}
                      readOnly={this.state.readOnly}
                      is_video={document.is_video}
                      legacyDocument={true}
                      approvers={this.state.document.approvers}
                      owner={this.state.document.uploaded_by_user}
                      updateSelectedCommentId={this.updateSelectedCommentId}
                      selectedCommentId={this.state.selectedCommentId}
                      approved={this.state.document.approved}
                      reloadConversations={this.loadConversations}
                      libraryId={this.state.document.library_id}
                      viewingCurrentVersion={
                        !this.state.versionId ||
                        (this.state.versionId &&
                          this.state.versionId === this.state.docId)
                      }
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={
                      this.state.commentXfdfHighlightId !== null &&
                      !this.state.downloadingFile
                    }
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <CommentPanel
                      setConversationsInitiated={this.setConversationsInitiated}
                      conversationsInitiated={this.state.conversationsInitiated}
                      setPreviousConvoId={this.setPreviousConvoId}
                      currentXfdfHighlightId={this.state.currentXfdfHighlightId}
                      currentXfdfHighlightString={
                        this.state.currentXfdfHighlightString
                      }
                      closeConversation={this.onCloseConversation}
                      pageNumber={this.state.currentXfdfHighlightPageIndex + 1}
                      docId={document.id}
                      readOnly={this.state.readOnly}
                      is_video={document.is_video}
                      legacyDocument={false}
                      updateSelectedCommentId={this.updateSelectedCommentId}
                      selectedCommentId={this.state.selectedCommentId}
                      approvers={this.state.document.approvers}
                      owner={this.state.document.uploaded_by_user}
                      approved={this.state.document.approved}
                      reloadConversations={this.loadConversations}
                      libraryId={this.state.document.library_id}
                      viewingCurrentVersion={
                        !this.state.versionId ||
                        (this.state.versionId &&
                          this.state.versionId === this.state.docId)
                      }
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showingReferences === true}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <ReferenceDocumentPanel
                      key={this.state.document.id}
                      close={this.onClickCloseReferenceDocumentPanel}
                      docId={this.state.docId}
                      referenceDocuments={this.props.referenceDocuments}
                      versionId={this.state.versionId}
                      versionNumber={this.state.versionNumber}
                      originalDocumentId={this.state.document.id}
                      showReferencesLibrary={() =>
                        this.setState({ showReferencesLibrary: true })
                      }
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showingDocumentReferences === true}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <DocumentReferencePanel
                      key={this.state.document.id}
                      closeDocumentReferencePanel={
                        this.closeDocumentReferencePanel
                      }
                      versionId={this.state.versionId}
                      versionNumber={this.state.versionNumber}
                      docId={this.state.docId}
                      originalDocumentId={this.state.document.id}
                      isApproved={this.state.document.approved}
                      readOnly={this.state.readOnly}
                      onAnnotationSelect={this.onAnnotationSelect}
                      startEditingDocumentReferences={
                        this.startEditingDocumentReferences
                      }
                      stopEditingDocumentReferences={
                        this.stopEditingDocumentReferences
                      }
                      editingDocumentReferences={
                        this.state.editingDocumentReferences
                      }
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showingAttachments === true}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <DocumentAttachmentsPanel
                      key={this.state.document.id}
                      close={this.onClickCloseAttachments}
                      docId={this.state.docId}
                      attachments={this.state.attachments}
                      handleDeleteAttachmentModalOpen={
                        this.handleDeleteAttachmentModalOpen
                      }
                      handleRenameAttachmentModalOpen={
                        this.handleRenameAttachmentModalOpen
                      }
                      showAttachmentFailNotification={
                        this.showAttachmentFailNotification
                      }
                      documentApproved={this.state.latestApproved}
                      owner={
                        this.state.document.uploaded_by_user_id ===
                        this.state.currentUser.id
                      }
                      sortDocumentAttachments={this.sortDocumentAttachments}
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showingVersions === true}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <DocumentVersionsPanel
                      key={this.state.document.id}
                      onClickCloseVersions={this.onClickCloseVersions}
                      docId={this.state.docId}
                      versionId={this.state.versionId}
                      onClickedVersion={this.onClickedVersion}
                      readOnly={this.state.readOnly}
                      versions={this.state.versions}
                      approved={this.state.document.approved}
                      nonVideoVersionsExist={this.state.nonVideoVersionsExist}
                      uploadNewVersion={
                        !this.state.document.is_video
                          ? this.uploadNewVersion
                          : () =>
                              history.push(
                                `/drafts/${this.state.document.id}/update_video`
                              )
                      }
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.selectedSignature !== null}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <SignaturePanel
                      signature={this.state.selectedSignature}
                      setSelectedSignature={this.setSelectedSignature}
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showShareLinkPanel}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <ShareLink
                      links={this.state.shareLinks}
                      numShareLinks={this.getNumberShareLinks()}
                      docId={this.state.docId}
                      retrieveShareLinks={this.retrieveShareLinks}
                      closePanel={this.closeShareLinkPanel}
                      setShowActivityModal={this.setShowActivityModal}
                      setSelectedShareLink={this.setSelectedShareLink}
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showTranslationsPanel}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <Translations
                      translations={this.state.translations}
                      numTranslations={this.getNumberTranslations()}
                      docId={this.state.docId}
                      retrieveTranslations={this.retrieveDocumentTranslations}
                      closePanel={this.closeTranslationsPanel}
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showChatsPanel}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <Chats
                      docId={this.state.docId}
                      closePanel={this.closeChatsPanel}
                      currentSessionId={this.state.currentChatSessionId}
                      onSessionChange={this.handleChatSessionChange}
                      onCitationClick={this.handleChatCitationClick}
                      paigeStatus={this.state.document.paige_status}
                      onPaigeStatusChange={this.handlePaigeStatusChange}
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showPaigeReviewPanel}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <PaigeReview
                      docId={this.state.docId}
                      closePanel={this.closePaigeReviewPanel}
                      onFindingClick={this.handlePaigeReviewFindingClick}
                      onAnalysisUpdate={this.handlePaigeReviewAnalysisUpdate}
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showClaimsPanel}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <Claims
                      closePanel={this.hideClaimsPanel}
                      selectedClaim={this.state.selectedClaim}
                      setSelectedClaim={this.setSelectedClaim}
                      onAnnotationDeselect={this.onAnnotationDeselect}
                      viewingCurrentVersion={
                        !this.state.versionId ||
                        (this.state.versionId &&
                          this.state.versionId === this.state.docId)
                      }
                    />
                  </CSSTransition>
                  <CSSTransition
                    in={this.state.showTemplatePanel}
                    classNames="slide"
                    unmountOnExit
                    timeout={300}
                  >
                    <Template
                      templateFields={this.state.templateKeys}
                      templateKeysSchema={this.state.templateKeysSchema}
                      docId={this.state.docId}
                      closePanel={this.hideTemplatePanel}
                      viewingCurrentVersion={
                        !this.state.versionId ||
                        (this.state.versionId &&
                          this.state.versionId === this.state.docId)
                      }
                      readOnly={
                        this.state.document && this.state.document.approved
                      }
                    />
                  </CSSTransition>
                  {this.state.claimData && (
                    <CSSTransition
                      in={this.state.showLinkClaimPanel}
                      classNames="slide"
                      unmountOnExit
                      timeout={300}
                    >
                      <PaigeClaims
                        closePanel={this.hideLinkClaimPanel}
                        claimData={this.state.claimData}
                        docId={this.state.docId}
                        setcreatedClaim={this.setSelectedClaim}
                        onAnnotationDeselect={this.onAnnotationDeselect}
                        libraryId={this.state.document.library_id}
                        setClaimToLink={this.setClaimToLink}
                        claimXfdfHighlightId={this.state.claimXfdfHighlightId}
                        readOnly={this.state.readOnly}
                        library={this.state.document.library}
                      />
                    </CSSTransition>
                  )}
                </React.Fragment>
              )}
              {this.state.selectedShareLink && (
                <ShareLinkAnalyticsModal
                  link={this.state.selectedShareLink}
                  showActivityModal={this.state.showActivityModal}
                  setShowActivityModal={this.setShowActivityModal}
                />
              )}
              <Modal
                visible={this.state.renameModalOpen}
                width="540"
                height="270"
                effect="fadeInUp"
                onClickAway={() => this.handleCloseRenameModal()}
              >
                <div className={styles.renameContentContainer}>
                  <div>
                    <h1 className={styles.renameContentHeadline}>
                      Rename content
                    </h1>
                  </div>
                  <UikDivider />
                  <div className={styles.renameContentFormContainer}>
                    <UikFormInputGroup>
                      {getFieldDecorator(`title`, {
                        initialValue: this.state.document.title,
                        rules: [
                          {
                            required: true,
                            message: "Please enter a title.",
                          },
                        ],
                      })(
                        <UikInput
                          label="CONTENT NAME"
                          placeholder="Document Title"
                        />
                      )}
                    </UikFormInputGroup>
                  </div>
                  <UikDivider />
                  <div className={styles.renameContentFormButtons}>
                    <UikButton
                      className="floatRight"
                      onClick={(e) => this.handleRename(e)}
                      primary
                    >
                      Save
                    </UikButton>
                    <UikButton
                      className={[styles.renameCancelButton, "floatRight"]}
                      onClick={(e) => this.handleCloseRenameModal(e)}
                    >
                      Cancel
                    </UikButton>
                    <div className="clear" />
                  </div>
                </div>
              </Modal>
              <Modal
                visible={this.state.renameAttachmentModalOpen}
                width="540"
                height="270"
                effect="fadeInUp"
                onClickAway={(e) => this.handleCloseRenameAttachmentModal(e)}
              >
                <div className={styles.renameContentContainer}>
                  <div>
                    <h1 className={styles.renameContentHeadline}>
                      Rename Attachment
                    </h1>
                  </div>
                  <UikDivider />
                  <div className={styles.renameContentFormContainer}>
                    <UikFormInputGroup>
                      {getFieldDecorator(`title`, {
                        initialValue: this.state.attachmentTitle,
                        rules: [
                          {
                            required: true,
                            message: "Please enter a title.",
                          },
                        ],
                      })(
                        <UikInput
                          label="ATTACHMENT NAME"
                          placeholder="Document Title"
                        />
                      )}
                    </UikFormInputGroup>
                  </div>
                  <UikDivider />
                  <div className={styles.renameContentFormButtons}>
                    <UikButton
                      className="floatRight"
                      onClick={(e) => this.handleRenameAttachment(e)}
                      primary
                    >
                      Save
                    </UikButton>
                    <UikButton
                      className={[styles.renameCancelButton, "floatRight"]}
                      onClick={(e) => this.handleCloseRenameAttachmentModal(e)}
                    >
                      Cancel
                    </UikButton>
                    <div className="clear" />
                  </div>
                </div>
              </Modal>
              <NewModal
                hideModal={this.hideContentDetailsModal}
                visible={this.state.showContentDetailsModal}
                type="regular"
              >
                <div className="heading">Edit Content Properties</div>
                <UikDivider />
                <div className="body">
                  {this.renderEditDocumentFieldValuesForm()}
                </div>
                <div className="clear" />
                <div className="dividerContainer">
                  <UikDivider />
                </div>
                <div className="buttons">
                  <UikButton
                    onClick={(e) => this.handleDocumentFieldValuesUpdate(e)}
                    primary
                  >
                    Save
                  </UikButton>
                  <UikButton onClick={this.hideContentDetailsModal}>
                    Cancel
                  </UikButton>
                </div>
              </NewModal>
              <NewModal
                hideModal={this.hideDeleteModal}
                visible={this.state.showDeleteModal}
                type="alert"
              >
                <div className="heading">Confirm Delete</div>
                <UikDivider />
                <div className="body">
                  {`Are you sure you want to delete ${this.state.document.title} ?`}
                </div>
                <UikDivider />
                {this.state.versions.length === 1 ? (
                  <div className="buttons">
                    <UikButton onClick={this.deleteAllVersions} primary>
                      Delete
                    </UikButton>
                    <UikButton onClick={this.hideDeleteModal}>Cancel</UikButton>
                  </div>
                ) : (
                  <div className="buttons">
                    <UikButton onClick={this.deleteCurrentVersion} primary>
                      This Version
                    </UikButton>
                    <UikButton onClick={this.deleteAllVersions} primary>
                      All Versions
                    </UikButton>
                    <UikButton onClick={this.hideDeleteModal}>Cancel</UikButton>
                  </div>
                )}
              </NewModal>
              <NewModal
                hideModal={this.hideDeleteModal}
                visible={this.state.showDeleteAttachmentModal}
                type="alert"
              >
                <div className="heading">Confirm Delete</div>
                <UikDivider />
                <div className="body">
                  Are you sure you want to delete this attachment?
                </div>
                <UikDivider />
                <div className="buttons">
                  <UikButton onClick={this.handleDeleteAttachment} primary>
                    Delete
                  </UikButton>
                  <UikButton onClick={this.hideDeleteAttachmentModal}>
                    Cancel
                  </UikButton>
                </div>
              </NewModal>
              <NewModal
                hideModal={this.hideDownloadModal}
                visible={this.state.showDownloadModal}
                type="alert"
              >
                <div className="heading">Download Options</div>
                <UikDivider />
                <div className="body">
                  <div className={styles.downloadModalOption}>
                    <span>
                      {this.state.document.mime_type === "application/pdf"
                        ? "PDF"
                        : `${this.fileFormat()} file`}{" "}
                      originally uploaded
                    </span>
                    <UikButton
                      primary
                      onClick={(e) => this.handleDownload(e)}
                      className={styles.downloadButton}
                    >
                      Download
                    </UikButton>
                  </div>
                  {this.state.document.mime_type !== "application/pdf" && (
                    <div className={styles.downloadModalOption}>
                      PDF without comments and references
                      <UikButton
                        primary
                        onClick={(e) =>
                          this.handleDownloadPDFWithoutComments(e)
                        }
                        className={styles.downloadButton}
                      >
                        Download
                      </UikButton>
                    </div>
                  )}
                  {this.state.conversations && (
                    <div className={styles.downloadModalOption}>
                      PDF with comments and references
                      <UikButton
                        primary
                        onClick={(e) => this.handleDownloadPDFWithComments(e)}
                        className={styles.downloadButton}
                      >
                        Download
                      </UikButton>
                    </div>
                  )}
                </div>
                <UikDivider />
                <div className="buttons">
                  <UikButton onClick={this.hideDownloadModal}>Cancel</UikButton>
                </div>
              </NewModal>
            </Row>
          ) : (
            this.state.documentLoaded && (
              <div className={styles.invalidDocument}>
                <img src={Warning} className={styles.warning} />
                <div className={styles.heading}>This file does not exist.</div>
                <Link to="/dashboard">
                  <UikButton primary>Back</UikButton>
                </Link>
              </div>
            )
          )}
          <NewModal
            hideModal={this.hideReferencesMigratedModal}
            visible={this.state.showReferencesMigratedModal}
            type="alert"
          >
            <div className="heading">Migration Complete</div>
            <UikDivider />
            <div className="body">
              <p>
                References from the previous version have successfully migrated
                to the newest version.
              </p>
              <p>
                Please check to ensure changes in the new version have not
                affected the migrated annotations.
              </p>
            </div>
            <UikDivider />
            <div className="buttons">
              <UikButton onClick={this.hideReferencesMigratedModal} primary>
                OK
              </UikButton>
            </div>
          </NewModal>
        </Container>
        {this.state.showReferencesLibrary && (
          <ReferencesLibrary
            libraryId={this.state.document.library_id}
            onClose={this.onCloseReferenceLibrary}
            docId={this.state.docId}
            linkingReference={true}
          />
        )}
      </React.Fragment>
    );
  }
}

const DocumentViewer = createForm()(DocumentViewerBuild);

const mapStateToProps = (state) => {
  return {
    referenceDocuments: state.referenceDocuments,
    claims: state.claims,
    documentClaims: state.documentClaims,
    documentDynamicFields: state.documentDynamicFields,
    documentReferences: state.documentReferences,
    documentConversations: state.documentConversations,
  };
};

const actionCreators = {
  fetchReferenceDocuments,
  fetchClaims,
  fetchDocumentClaims,
  fetchDocumentDynamicFields,
  resetDocumentState,
  fetchDocumentReferences,
  fetchDocumentConversations,
};

export default connect(mapStateToProps, actionCreators)(DocumentViewer);
